import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Calendar,
  Cloud,
  Sun,
  CloudRain,
  Thermometer,
  Clock,
  ChevronRight,
  ArrowLeft,
  Sparkles,
  AlertCircle,
  Download,
  Share2,
  Mail,
  Users,
  MessageCircle,
  Link as LinkIcon,
  Copy,
  FileText,
  Star,
  X,
  Trash2,
  Coins,
  PiggyBank,
  Banknote,
  AlertTriangle
} from 'lucide-react';

import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import {
  getWeatherCondition,
  weatherConditionFromCode,
  daysFromRange,
  latLonToXY,
  svgPlaceholderDataUrl,
  categorizeAttractions,
  getCuratedAttractions,
  formatIcsDate,
  icsEventLines,
  generateItinerary,
  addDaysToISO,
  firstSentence,
  shortActionLine,
  buildSixLineStory,
} from "./utils/utils";

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import 'leaflet/dist/leaflet.css';
import { supabase } from "./lib/supabase";

import * as Y from 'yjs';
import { WebrtcProvider } from 'y-webrtc';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Tooltip, useMap } from 'react-leaflet';
import DestinationMap from "./DestinationMap";
import FixMyDay from "./FixMyDay";
import TravelStoryModal from "./TravelStoryModal";
import BudgetTrackerModal from "./BudgetTrackerModal";
import EmergencyHubModal from "./EmergencyHubModal";
import UtilityFinderModal from "./UtilityFinderModal";
import MicroExperiencesModal from "./MicroExperiencesModal";


import { buildSkyscannerFlightsUrl } from "./utils/skyscanner";
import SkyscannerCTA from "./components/SkyscannerCTA";
import SkyscannerTopAd from "./components/SkyscannerTopAd";
import HomePage from "./HomePage";
   
function AdSlot({ id, label = "Ad", className = "" }) {
  return (
    <div
      id={id}
      className={[
        "w-full rounded-xl border border-dashed border-slate-300 bg-slate-50",
        "flex items-center justify-center text-slate-500",
        "overflow-hidden",
        className,
      ].join(" ")}
      aria-label={label}
      role="complementary"
    >
      <div className="text-center px-4">
        <div className="text-xs font-semibold uppercase tracking-wide">
        <div className="text-center px-4">
		  <div className="text-sm font-semibold text-slate-700">
		    Reach travelers while they plan
		  </div>
		  <p className="mt-1 text-xs text-slate-500">
		    Your brand here — inspire journeys at the moment of decision.
		  </p>
		 <a
  href="https://mail.google.com/mail/?view=cm&to=buthpur@itinex.net&su=Advertising%20with%20Itinex&body=Hi%20Itinex%20Team,%0A%0AI%20am%20interested%20in%20advertising%20on%20Itinex."
  target="_blank"
  rel="noopener noreferrer"
  className="mt-3 inline-flex items-center px-3 py-1.5 rounded-md bg-itinex-primary text-white text-xs font-semibold hover:opacity-90"
>
  Advertise with Itinex
</a>

		</div>
		</div>
        <div className="text-[11px] mt-1 text-slate-400">{id}</div>
      </div>
    </div>
  );
}

const VoteBar = ({ k, totals, onVote }) => {
  const map = totals || {};
  const v = map[k] || { likes: 0, dislikes: 0, reactions: 0 };

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          console.log("LIKE clicked:", k);
          onVote(k, 1);
        }}
        className="px-2 py-1 rounded-full text-xs border bg-white"
      >
        👍 {v.likes}
      </button>

      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          console.log("DISLIKE clicked:", k);
          onVote(k, -1);
        }}
        className="px-2 py-1 rounded-full text-xs border bg-white"
      >
        👎 {v.dislikes}
      </button>

      {/*<span className="text-xs text-white">Reactions {v.reactions}</span>*/}
    </div>
  );
};

export default function HolidayPlanner() {

  const [step, setStep] = useState('select');
  const [destinations, setDestinations] = useState([]);
  const [selectedDest, setSelectedDest] = useState(null);
  const [days, setDays] = useState(3);
  const [weather, setWeather] = useState(null);
  const [itinerary, setItinerary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDests, setLoadingDests] = useState(true);
  const [error, setError] = useState(null);


  const [shareUrl, setShareUrl] = useState('');
  const [roomId, setRoomId] = useState('');
  const [presenceCount, setPresenceCount] = useState(1);

  const [commentName, setCommentName] = useState('Me');
  const [commentText, setCommentText] = useState('');
  const [comments, setComments] = useState([]);

  const [showReviews, setShowReviews] = useState(false);
  const [selectedReviewDest, setSelectedReviewDest] = useState(null);
  const [reviewName, setReviewName] = useState('');
  const [reviewText, setReviewText] = useState('');
  const [reviewRating, setReviewRating] = useState(5);
  const [destinationReviews, setDestinationReviews] = useState({});
const [selectView, setSelectView] = useState('grid'); 
const [fixMyDayOpen, setFixMyDayOpen] = useState(false);

  const pdfRef = useRef(null);
  const [exportingPdf, setExportingPdf] = useState(false);
  const weatherAbortRef = useRef(null);
  const utilityReqIdRef = useRef(0);
const utilityAbortRef = useRef(null);
const navigate = useNavigate();
const location = useLocation();
const { slug } = useParams();
   useEffect(() => {
  // Always scroll to top on route change (important for SEO landing pages)
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "instant"
  });
}, [location.pathname]);

const slugify = (s) =>
  String(s || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");

const isDestinationSeoPage =
  location.pathname.startsWith("/destinations/") && !!slug;

// Find destination by slug from loaded destinations[]
const seoDest = React.useMemo(() => {
  if (!isDestinationSeoPage || !slug || !Array.isArray(destinations)) return null;

  return destinations.find((d) => {
    const name = d?.name || "";
    const country = d?.country || "";
    const s = slugify(`${name}-${country}`);
    return s === slug;
  });
}, [isDestinationSeoPage, slug, destinations]);


  const destToSlug = (d) => slugify(`${d?.name || ""}-${d?.country || ""}`);
const footerPages = new Set([
  "/about",
  "/contact",
  "/advertise",
  "/privacy",
  "/terms",
]);

const isFooterPage = footerPages.has(location.pathname);
const [attractionsSource, setAttractionsSource] = useState(null);
const [attractionsMap, setAttractionsMap] = useState({});
const _attractionImageCache = new Map(); 
const [attractionImages, setAttractionImages] = useState({}); 
const [attractionsForTrip, setAttractionsForTrip] = useState(null);
const [hoveredDestId, setHoveredDestId] = useState(null);
const [useDateRange, setUseDateRange] = useState(true);
const [startDate, setStartDate] = useState(() => new Date().toISOString().slice(0, 10)); 
const [showBudget, setShowBudget] = useState(false);
const [budgetOpen, setBudgetOpen] = useState(false);
const [fixOpen, setFixOpen] = useState(false);
const [storyOpen, setStoryOpen] = useState(false);
const [travelStory, setTravelStory] = useState(false)
const [emergencyOpen, setEmergencyOpen] = useState(false);
const [toolsOpen, setToolsOpen] = useState("");
const [emergencyNumbers, setEmergencyNumbers] = useState({});
const [emergencyPhrases, setEmergencyPhrases] = useState({});

const [endDate, setEndDate] = useState(() => {
const d = new Date();
  d.setDate(d.getDate() + 2);
  return d.toISOString().slice(0, 10);
});
const [viewMode, setViewMode] = useState("itinerary"); // "itinerary" | "story"
const storyRef = useRef(null);
const [storySummaries, setStorySummaries] = useState({}); 
// { [placeName]: { title, extract, url, image } }
const [loadingStory, setLoadingStory] = useState(false);
const [storyText, setStoryText] = useState("");
const [isStoryLoading, setIsStoryLoading] = useState(false);


const [hiddenGemsMode, setHiddenGemsMode] = useState(false);
const [surpriseLevel, setSurpriseLevel] = useState(0.35); // 0..1
const [voteTotals, setVoteTotals] = useState({});
// voteTotals[attraction_key] = { likes, dislikes, reactions }
const buildAttractionKey = (destName, attractionName) =>
  slugify(`${destName || ""}::${attractionName || ""}`);

const [activeNav, setActiveNav] = useState("home"); 
const [mobileNavOpen, setMobileNavOpen] = useState(false);
const [votes, setVotes] = useState({}); 

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const [nearbyPlaces, setNearbyPlaces] = useState([]);

const [mapWeatherById, setMapWeatherById] = useState({}); 

const [loadingMapWeather, setLoadingMapWeather] = useState(false);

const [savedTrips, setSavedTrips] = useState([]);

// -------------------- Utility Finder helpers --------------------
const _coordsCache = new Map();       // placeName -> { lat, lon, source }
const _nearestCache = new Map();      // `${placeName}::${type}` -> result

const safeFixed2 = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n.toFixed(2) : null;
};


const haversineKm = (aLat, aLon, bLat, bLon) => {
  const toRad = (x) => (x * Math.PI) / 180;
  const R = 6371;
  const dLat = toRad(bLat - aLat);
  const dLon = toRad(bLon - aLon);
  const lat1 = toRad(aLat);
  const lat2 = toRad(bLat);
  const x =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(x));
};

// 1) Try Wikipedia summary coords
async function wikiSummaryCoords(placeName) {
  const res = await fetch(
    `https://en.wikipedia.org/api/rest_v1/page/summary/${encodeURIComponent(placeName)}`
  );
  if (!res.ok) return null;
  const data = await res.json();
  const lat = data?.coordinates?.lat;
  const lon = data?.coordinates?.lon;
  if (Number.isFinite(lat) && Number.isFinite(lon)) return { lat, lon, source: "wikipedia" };
  return null;
}

// 2) Wikipedia search -> best title -> summary coords
async function wikiSearchCoords(placeName, countryHint = "") {
  const q = `${placeName} ${countryHint}`.trim();
  const sRes = await fetch(
    `https://en.wikipedia.org/w/api.php?action=query&list=search&srsearch=${encodeURIComponent(
      q
    )}&format=json&origin=*`
  );
  if (!sRes.ok) return null;
  const sData = await sRes.json();
  const bestTitle = sData?.query?.search?.[0]?.title;
  if (!bestTitle) return null;
  const coords = await wikiSummaryCoords(bestTitle);
  return coords ? { ...coords, source: "wikipedia_search" } : null;
}

// 3) Nominatim geocode (OSM)
async function nominatimCoords(placeName, countryHint = "") {
  const q = `${placeName}${countryHint ? `, ${countryHint}` : ""}`;
  const url = `https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&q=${encodeURIComponent(
    q
  )}`;

  const res = await fetch(url, {
    headers: { Accept: "application/json" },
  });
  if (!res.ok) return null;

  const data = await res.json();
  const hit = data?.[0];
  const lat = hit?.lat ? Number(hit.lat) : null;
  const lon = hit?.lon ? Number(hit.lon) : null;
  if (Number.isFinite(lat) && Number.isFinite(lon)) return { lat, lon, source: "nominatim" };
  return null;
}

// Main: get coords with fallbacks + caching
async function getCoordsForPlace(placeName, selectedDest) {
  const key = String(placeName || "").trim().toLowerCase();
  if (!key) return null;

  if (_coordsCache.has(key)) return _coordsCache.get(key);

  const countryHint = selectedDest?.country || "";

  // A) Wiki summary
  try {
    const a = await wikiSummaryCoords(placeName);
    if (a) {
      _coordsCache.set(key, a);
      return a;
    }
  } catch {}

  // B) Wiki search
  try {
    const b = await wikiSearchCoords(placeName, countryHint);
    if (b) {
      _coordsCache.set(key, b);
      return b;
    }
  } catch {}

  // C) Nominatim
  try {
    const c = await nominatimCoords(placeName, countryHint);
    if (c) {
      _coordsCache.set(key, c);
      return c;
    }
  } catch {}

  // D) Destination fallback
  if (Number.isFinite(selectedDest?.lat) && Number.isFinite(selectedDest?.lon)) {
    const d = { lat: selectedDest.lat, lon: selectedDest.lon, source: "destination_fallback" };
    _coordsCache.set(key, d);
    return d;
  }

  return null;
}

useEffect(() => {
  if (!slug) return;
  if (!destinations?.length) return;

  const found = destinations.find((d) => d.slug === slug);

  if (found) {
    setSelectedDest(found);
    setStep("days");
    window.scrollTo(0, 0);
  }
}, [slug, destinations]);

useEffect(() => {
  if (!isDestinationSeoPage) return;
  if (!destinations?.length) return;

  const match = destinations.find((d) => destToSlug(d) === slug);

  if (match) {
    setSelectedDest(match);
    // IMPORTANT: do NOT navigate away, keep this URL
    // Set a view mode that shows destination content
    setStep("select"); // or a new step like "destSeo"
  }
}, [isDestinationSeoPage, slug, destinations]);


// Overpass: fetch nearest amenity (hospital/pharmacy)
async function fetchNearestAmenity({ originLat, originLon, type, signal }) {
  const tag = type === "hospital" ? 'amenity="hospital"' : 'amenity="pharmacy"';
  const radii = [6000, 12000, 25000]; // faster first hit

  for (const radius of radii) {
    const query = `
[out:json][timeout:18];
(
  node[${tag}](around:${radius},${originLat},${originLon});
  way[${tag}](around:${radius},${originLat},${originLon});
  relation[${tag}](around:${radius},${originLat},${originLon});
);
out center 25;
`;

    const res = await fetch("https://overpass-api.de/api/interpreter", {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: query,
      signal,
    });

    if (!res.ok) continue;
    const data = await res.json();
    const els = data?.elements || [];
    if (!els.length) continue;

    const best = els
      .map((el) => {
        const lat = el.lat ?? el.center?.lat;
        const lon = el.lon ?? el.center?.lon;
        if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
        return {
          name: el.tags?.name || (type === "hospital" ? "Hospital" : "Pharmacy"),
          lat,
          lon,
          approxKm: haversineKm(originLat, originLon, lat, lon),
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.approxKm - b.approxKm)[0];

    if (best) return best;
  }

  return null;
}



function openGoogleMapsDrivingDirections({ originLat, originLon, destLat, destLon }) {
  const url =
    `https://www.google.com/maps/dir/?api=1` +
    `&origin=${originLat},${originLon}` +
    `&destination=${destLat},${destLon}` +
    `&travelmode=driving`;
  window.open(url, "_blank", "noopener,noreferrer");
}

const SAVED_TRIPS_KEY = "itinex:savedTrips";
const destKey = (dest) => {
  // prefer stable explicit id if you have it
  if (dest?.id !== undefined && dest?.id !== null) return slugify(dest.id);

  // else use name/country fallback
  const name = dest?.name ? String(dest.name) : "";
  const country = dest?.country ? String(dest.country) : "";
  return slugify(`${name}-${country}`);
};
const activityId = (destName, attractionName) =>
  slugify(`${destName || ""}::${attractionName || ""}`);



const fetchReviewsForDestination = async (destinationId) => {
  if (!destinationId) return;

  try {
    const { data, error } = await supabase
      .from("reviews")
      .select("id,destination_id,destination_name,author,text,rating,created_at")
      .eq("destination_id", destinationId)
      .order("created_at", { ascending: false });

    if (error) throw error;

    const normalized = (data || []).map((r) => ({
      id: r.id,
      destinationId: r.destination_id,
      destinationName: r.destination_name,
      author: r.author,
      text: r.text,
      rating: r.rating,
      ts: new Date(r.created_at).getTime(),
    }));

    setDestinationReviews((prev) => ({
      ...prev,
      [destinationId]: normalized,
    }));
  } catch (err) {
    console.error("Failed to fetch destination reviews:", err);
  }
};

{/* Remove after New Year */}
const [showMarketingModal, setShowMarketingModal] = useState(false);

useEffect(() => {
  const path = location.pathname;

  if (path.startsWith("/destinations/")) {
    setActiveNav("destinations");
    setStep("select"); // or your SEO view
    return;
  }

  if (path.startsWith("/destinations/")) {
    setActiveNav("destinations");
    setStep("days");
    return;
  }

  // Tabs
  if (path === "/") {
    setActiveNav("home");
    setStep("select");
    return;
  }

  if (path === "/destinations") {
    setActiveNav("destinations");
    setStep("select");
    return;
  }

  if (path === "/map") {
    setActiveNav("map");
    setStep("map");
    return;
  }

  if (path === "/saved") {
    setActiveNav("saved");
    setStep("saved");
    return;
  }

  // Footer pages
  if (path === "/about") {
    //setActiveNav("about");
    setStep("select"); // or keep current; just ensure UI renders the section
    return;
  }
  if (path === "/contact") {
    //setActiveNav("contact");
    setStep("select");
    return;
  }
  if (path === "/advertise") {
    //setActiveNav("advertise");
    setStep("select");
    return;
  }
  if (path === "/privacy") {
    //setActiveNav("privacy");
    setStep("select");
    return;
  }
  if (path === "/terms") {
    //setActiveNav("terms");
    setStep("select");
    return;
  }

  // Planner flow pages
  if (path === "/planner/dates") {
    //setActiveNav("planner");
    setStep("days");
    return;
  }

  if (path === "/planner/itinerary") {
    //setActiveNav("planner");
    setStep("itinerary");
    return;
  }
}, [location.pathname]);

useEffect(() => {
  const seen = localStorage.getItem("itinex_ny2026_seen");
  if (!seen) {
    const timer = setTimeout(() => {
      setShowMarketingModal(true);
      localStorage.setItem("itinex_ny2026_seen", "true");
    }, 1500); // delay feels natural

    return () => clearTimeout(timer);
  }
}, []);

// --- Budget tracker ---
const [currency, setCurrency] = useState("GBP");

// Structure:
// budgetData = {
//   overallBudget: number,
//   dailyBudgets: { [isoDateOrDayKey]: number },
//   expenses: [
//     { id, ts, dayKey, category, note, planned, actual }
//   ]
// }
const [budgetData, setBudgetData] = useState({
  overallBudget: 0,
  dailyBudgets: {},
  expenses: [],
});

const BUDGET_KEY = (tripId) => `itinex:budget:${tripId}`;

function getTripIdForBudget() {
  if (!selectedDest) return "no-trip";
  return roomId || `local-${destKey(selectedDest)}`;
}

function loadBudget(tripId) {
  try {
    const raw = localStorage.getItem(BUDGET_KEY(tripId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return {
      overallBudget: Number(parsed.overallBudget || 0),
      dailyBudgets: parsed.dailyBudgets || {},
      expenses: Array.isArray(parsed.expenses) ? parsed.expenses : [],
    };
  } catch {
    return null;
  }
}

function persistBudget(tripId, next) {
  localStorage.setItem(BUDGET_KEY(tripId), JSON.stringify(next));
}

useEffect(() => {
  if (showBudget) {
    document
      .getElementById("budget-section")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}, [showBudget]);


// Keep budget scoped to the current tripId
useEffect(() => {
  if (step !== "itinerary" || !selectedDest) return;
  const tripId = getTripIdForBudget();
  const loaded = loadBudget(tripId);
  if (loaded) setBudgetData(loaded);
  else setBudgetData({ overallBudget: 0, dailyBudgets: {}, expenses: [] });
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [step, roomId, selectedDest?.name]);

// Persist when it changes
useEffect(() => {
  if (step !== "itinerary" || !selectedDest) return;
  const tripId = getTripIdForBudget();
  persistBudget(tripId, budgetData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [budgetData, step, roomId, selectedDest?.name]);

const [placeModalOpen, setPlaceModalOpen] = useState(false);
const [activePlace, setActivePlace] = useState(null);
const [placeDetails, setPlaceDetails] = useState(null);
const [placeLoading, setPlaceLoading] = useState(false);
const [utilityModalOpen, setUtilityModalOpen] = useState(false);
const [utilityModalLoading, setUtilityModalLoading] = useState(false);
const [utilityModalData, setUtilityModalData] = useState(null);

const openNearestUtility = async (placeName, type) => {
  if (!placeName || !type) return;

  // 1) Cancel any in-flight request
  if (utilityAbortRef.current) utilityAbortRef.current.abort();
  const controller = new AbortController();
  utilityAbortRef.current = controller;

  // 2) Increment request id (prevents stale responses from updating UI)
  const reqId = ++utilityReqIdRef.current;

  const cacheKey = `${String(placeName).trim().toLowerCase()}::${type}`;

  // 3) OPEN modal immediately and CLEAR old result (fixes “previous attraction shown”)
  setUtilityModalOpen(true);
  setUtilityModalLoading(true);
  setUtilityModalData({
    placeName,
    type,
    originLat: null,
    originLon: null,
    coordSource: null,
    result: null,
    error: null,
    // Immediate “Maps fallback” is per attraction (never stale)
    mapsSearchUrl:
      type === "pharmacy"
        ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`pharmacy near ${placeName}`)}`
        : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`hospital near ${placeName}`)}`,
  });

  // 4) If you want caching, only use it AFTER clearing UI (still correct)
  if (_nearestCache.has(cacheKey)) {
    const cached = _nearestCache.get(cacheKey);
    // stale guard
    if (reqId !== utilityReqIdRef.current) return;
    setUtilityModalData((prev) => ({
      ...prev,
      ...cached,
      placeName,
      type,
    }));
    setUtilityModalLoading(false);
    return;
  }

  try {
    // 5) Get coords (with fallback), support abort + stale guard
    const coords = await getCoordsForPlace(placeName, selectedDest);
    if (controller.signal.aborted || reqId !== utilityReqIdRef.current) return;

    if (!coords) {
      setUtilityModalData((prev) => ({
        ...prev,
        error: null, // don't show scary error
      }));
      setUtilityModalLoading(false);
      return;
    }

    // Store origin for directions + keep mapsSearchUrl correct
    setUtilityModalData((prev) => ({
      ...prev,
      originLat: coords.lat,
      originLon: coords.lon,
      coordSource: coords.source,
    }));

    // 6) Fetch nearest amenity (Overpass) — allow abort
    const nearest = await fetchNearestAmenity({
      originLat: coords.lat,
      originLon: coords.lon,
      type,
      signal: controller.signal, // add this support below
    });

    if (controller.signal.aborted || reqId !== utilityReqIdRef.current) return;

    if (!nearest) {
      // Don’t say “not found”. Keep Maps fallback only.
      setUtilityModalLoading(false);
      return;
    }

    const payload = {
      placeName,
      type,
      originLat: coords.lat,
      originLon: coords.lon,
      coordSource: coords.source,
      result: nearest,
      error: null,
      mapsSearchUrl: null,
    };

    _nearestCache.set(cacheKey, payload);

    setUtilityModalData(payload);
  } catch (e) {
    if (e?.name === "AbortError") return;
    if (reqId !== utilityReqIdRef.current) return;

    // Don’t show failure to travelers; keep Maps fallback visible
    setUtilityModalData((prev) => ({ ...prev, error: null }));
  } finally {
    if (reqId === utilityReqIdRef.current) setUtilityModalLoading(false);
  }
};


const fetchPlaceDetails = async (placeName) => {
  if (!placeName) return;

  setPlaceLoading(true);
  setPlaceDetails(null);
  setNearbyPlaces([]);

  try {
    // 1️⃣ Fetch main place summary
    const res = await fetch(
      `https://en.wikipedia.org/api/rest_v1/page/summary/${encodeURIComponent(placeName)}`
    );
    if (!res.ok) throw new Error("Not found");

    const data = await res.json();

    setPlaceDetails({
      title: data.title,
      description: data.extract,
      image: data.thumbnail?.source || null,
      url: data.content_urls?.desktop?.page || null
    });

    // 2️⃣ Fetch nearby attractions (if coordinates exist)
    if (data.coordinates?.lat && data.coordinates?.lon) {
      const geoRes = await fetch(
        `https://en.wikipedia.org/w/api.php?action=query&list=geosearch&gscoord=${data.coordinates.lat}|${data.coordinates.lon}&gsradius=1500&gslimit=6&format=json&origin=*`
      );

      const geoData = await geoRes.json();

      const nearby =
        geoData?.query?.geosearch
          ?.filter(p => p.title !== data.title)
          ?.map(p => p.title) || [];

      setNearbyPlaces(nearby);
    }
  } catch {
    setPlaceDetails({
      title: placeName,
      description: "No additional details available.",
      image: null,
      url: null
    });
  } finally {
    setPlaceLoading(false);
  }
};
const openGoogleMapsDirections = (placeName) => {
  const url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    placeName
  )}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

// --- Micro-Experiences ---
const [microOpen, setMicroOpen] = useState(false);

// extrasByDayKey: { [isoDateOrDayKey]: MicroExperience[] }
const [microExtrasByDay, setMicroExtrasByDay] = useState({});

const MICRO_KEY = (tripId) => `itinex:micro:${tripId}`;

function loadMicro(tripId) {
  try {
    const raw = localStorage.getItem(MICRO_KEY(tripId));
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

const handleAttachMicro = (dayObj, exp) => {
  const author = commentName || "Anonymous";
  const when = `Day ${dayObj?.day}${dayObj?.date ? ` • ${dayObj.date}` : ""}`;
  const kindLabel = exp?.kind === "guide" ? "Guide" : "Event";
  const venue = exp?.venue ? ` @ ${exp.venue}` : "";
  const url = exp?.url ? `\n${exp.url}` : "";

  const text =
    `➕ Added ${kindLabel}: ${exp.title}${venue}\n` +
    `${when}${url}`;

  addCommentViaSingleton(author, text, setComments);
};

function persistMicro(tripId, next) {
  localStorage.setItem(MICRO_KEY(tripId), JSON.stringify(next));
}

useEffect(() => {
  if (step !== "itinerary" || !selectedDest) return;
  const tripId = getTripIdForBudget(); // you already have this helper
  setMicroExtrasByDay(loadMicro(tripId));
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [step, roomId, selectedDest?.name]);

useEffect(() => {
  if (step !== "itinerary" || !selectedDest) return;
  const tripId = getTripIdForBudget();
  persistMicro(tripId, microExtrasByDay);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [microExtrasByDay, step, roomId, selectedDest?.name]);


function loadSavedTrips() {
  try {
    const raw = localStorage.getItem(SAVED_TRIPS_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function persistSavedTrips(trips) {
  localStorage.setItem(SAVED_TRIPS_KEY, JSON.stringify(trips));
}
useEffect(() => {
  let title = "Itinex — Plan less. Explore more.";
  let desc =
    "Weather-aware travel itineraries built around real attractions.";

  if (step === "select") {
    title = "Choose your destination — Itinex";
    desc = "Explore destinations via map or grid and start planning.";
  }

  if (step === "days" && selectedDest) {
    title = `Plan your trip to ${selectedDest.name} — Itinex`;
    desc = `Choose trip dates and generate a smart itinerary for ${selectedDest.name}.`;
  }

  if (step === "itinerary" && selectedDest) {
    title = `${days}-day itinerary for ${selectedDest.name} — Itinex`;
    desc = `Your personalized, weather-aware itinerary for ${selectedDest.name}.`;
  }

  document.title = title;
  setMeta("description", desc);
  setOG("og:title", title);
  setOG("og:description", desc);
}, [step, selectedDest?.name, days]);

useEffect(() => {
  const trips = loadSavedTrips();
  setSavedTrips(trips);
}, []);
const saveCurrentTrip = () => {
  if (!selectedDest || !itinerary?.length) return;

  const now = Date.now();
  const trip = {
    id: cryptoRandomId(),
    ts: now,
    title: `${selectedDest.name} • ${days} day${days === 1 ? "" : "s"}`,
    selectedDest,
    days,
    startDate: useDateRange ? startDate : null,
    endDate: useDateRange ? endDate : null,
    weather,
    itinerary,
    shareUrl: shareUrl || "",
    budgetData,
    currency
  };

  setSavedTrips((prev) => {
    // de-dupe: same destination + same first day date + same length
    const sig = `${selectedDest.name}|${days}|${itinerary?.[0]?.date || ""}`;
    const next = [
      trip,
      ...prev.filter((t) => {
        const tSig = `${t?.selectedDest?.name}|${t?.days}|${t?.itinerary?.[0]?.date || ""}`;
        return tSig !== sig;
      }),
    ].slice(0, 50); // keep last 50

    persistSavedTrips(next);
    return next;
  });

  setError("Trip saved ✅");
};
useEffect(() => {
  if (step === "itinerary" && selectedDest && itinerary.length > 0) {
    saveCurrentTrip();
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [step, selectedDest?.name, itinerary]);
const openSavedTrip = (trip) => {
  if (!trip?.selectedDest || !trip?.itinerary?.length) return;

  setSelectedDest(trip.selectedDest);
  setDays(trip.days ?? trip.itinerary.length);
  setWeather(trip.weather ?? null);
  setItinerary(trip.itinerary);
  setStep("itinerary");
  setBudgetData(trip.budgetData ?? { overallBudget: 0, dailyBudgets: {}, expenses: [] });
  setCurrency(trip.currency ?? "GBP");
  setError(null);
};

const deleteSavedTrip = (id) => {
  setSavedTrips((prev) => {
    const next = prev.filter((t) => t.id !== id);
    persistSavedTrips(next);
    return next;
  });
};

useEffect(() => {
  if (step !== "map" || !destinations?.length) return;

  let cancelled = false;
  const controller = new AbortController();

  (async () => {
    setLoadingMapWeather(true);

    try {
      // fetch only for destinations not in cache yet
      const todo = destinations.filter((d) => !mapWeatherById[d.id]);
      if (todo.length === 0) return;

      // Limit concurrency to avoid hammering API
      const limit = 20;
      let idx = 0;

      const worker = async () => {
        while (idx < todo.length && !cancelled) {
          const d = todo[idx++];
          try {
            const url =
              `https://api.open-meteo.com/v1/forecast?latitude=${d.lat}&longitude=${d.lon}` +
              `&daily=weather_code&timezone=auto&forecast_days=1`;

            const res = await fetch(url, { signal: controller.signal });
            if (!res.ok) continue;

            const data = await res.json();
            const code = data?.daily?.weather_code?.[0];
            if (code === undefined || code === null) continue;

            const condition = weatherConditionFromCode(code);

            if (!cancelled) {
              setMapWeatherById((prev) => ({
                ...prev,
                [d.id]: { code, condition },
              }));
            }
          } catch (e) {
            if (e?.name === "AbortError") return;
          }
        }
      };

      await Promise.all(Array.from({ length: limit }, worker));
    } finally {
      if (!cancelled) setLoadingMapWeather(false);
    }
  })();

  return () => {
    cancelled = true;
    controller.abort();
  };
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [step, destinations]);

useEffect(() => {
  (async () => {
    try {
      const res = await fetch('/attractions.json');
      if (!res.ok) return;
      setAttractionsMap(await res.json());
    } catch {}
  })();
  (async () => {
    try {
      const res = await fetch("/emergency_numbers.json");
      if (res.ok) setEmergencyNumbers(await res.json());
    } catch {}
  })();

  (async () => {
    try {
      const res = await fetch("/emergency_phrases.json");
      if (res.ok) setEmergencyPhrases(await res.json());
    } catch {}
  })();
}, []);

useEffect(() => {
  if (step === 'select' && selectView === 'map') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}, [step, selectView]);

  useEffect(() => {
    try {
      const url = new URL(window.location.href);
      const trip = url.searchParams.get('trip');
      if (!trip) return;

      const json = decodeURIComponent(escape(atob(trip)));
      const parsed = JSON.parse(json);

      const view = url.searchParams.get("view");
      if (view === "story") setViewMode("story");

      if (parsed?.selectedDest && parsed?.itinerary?.length) {
  setSelectedDest(parsed.selectedDest);
  setDays(parsed.days ?? parsed.itinerary.length);
  setWeather(parsed.weather ?? null);
  setItinerary(parsed.itinerary);

  setUseDateRange(parsed.useDateRange ?? false);
  if (parsed.startDate) setStartDate(parsed.startDate);
  if (parsed.endDate) setEndDate(parsed.endDate);
  if (parsed?.viewMode) setViewMode(parsed.viewMode);
  if (parsed?.budgetData) setBudgetData(parsed.budgetData);
  if (parsed?.currency) setCurrency(parsed.currency);


  setStep('itinerary');
  setError(null);
}

    } catch (e) {}
  }, []);

  useEffect(() => {
    if (step !== 'itinerary' || !selectedDest || itinerary.length === 0) return;
    const base = `${selectedDest.name}|${days}|${itinerary?.[0]?.date ?? ''}`;
    setRoomId(`trip-${hashString(base)}`);
  }, [step, selectedDest?.name, days, itinerary]);

async function fetchWikiSummary(placeName) {
  if (!placeName) return null;

  try {
    const res = await fetch(
      `https://en.wikipedia.org/api/rest_v1/page/summary/${encodeURIComponent(placeName)}`
    );

    if (!res.ok) return null;

    const data = await res.json();
    return {
      title: data.title,
      extract: data.extract || "",
      url: data.content_urls?.desktop?.page || "",
      image: data.thumbnail?.source || null,
    };
  } catch (e) {
    return null;
  }
}

async function fetchUnsplashImage(query) {
	console.log('Unsplash key?', !!process.env.REACT_APP_UNSPLASH_ACCESS_KEY);

  if (!UNSPLASH_KEY) return null;

  // Search 1 photo for the query
  const url =
    `https://api.unsplash.com/search/photos?per_page=1&orientation=landscape` +
    `&query=${encodeURIComponent(query)}`;

  const res = await fetch(url, {
    headers: { Authorization: `Client-ID ${UNSPLASH_KEY}` }
  });

  if (!res.ok) return null;

  const data = await res.json();
  const photo = data?.results?.[0];
  // Use the returned hotlink URL from the API response
  return photo?.urls?.regular || photo?.urls?.full || null;
}

function FitBounds({ destinations }) {
  const map = useMap();

  React.useEffect(() => {
    if (!destinations?.length) return;

    const bounds = destinations
      .filter(d => Number.isFinite(d.lat) && Number.isFinite(d.lon))
      .map(d => [d.lat, d.lon]);

    if (!bounds.length) return;

    // If only one destination, center with zoom
    if (bounds.length === 1) {
      map.setView(bounds[0], 5, { animate: true });
      return;
    }

    map.fitBounds(bounds, { padding: [30, 30] });
  }, [destinations, map]);

  return null;
}
function upsertMeta(nameOrProp, value, isProp = false) {
  const selector = isProp ? `meta[property="${nameOrProp}"]` : `meta[name="${nameOrProp}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    if (isProp) el.setAttribute("property", nameOrProp);
    else el.setAttribute("name", nameOrProp);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(url) {
  let link = document.head.querySelector(`link[rel="canonical"]`);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

function NavButton({ active, children, onClick, disabled, title }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={[
        "px-3 py-2 rounded-lg text-sm font-semibold transition",
        "border",
        active
          ? "bg-slate-900 text-white border-slate-900"
          : "bg-white text-slate-700 border-transparent hover:bg-slate-50 hover:border-slate-200",
        disabled ? "opacity-50 cursor-not-allowed" : ""
      ].join(" ")}
    >
      {children}
    </button>
  );
}

function MobileNavItem({ children, onClick, disabled, className = "" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={[
        "px-3 py-2 rounded-lg border bg-white text-slate-700 text-sm font-semibold hover:bg-slate-50 transition",
        disabled ? "opacity-50 cursor-not-allowed" : "",
        className
      ].join(" ")}
    >
      {children}
    </button>
  );
}

function upsertMetaTag({ name, property, content }) {
  const selector = name
    ? `meta[name="${name}"]`
    : `meta[property="${property}"]`;

  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    if (name) el.setAttribute("name", name);
    if (property) el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonicalUrl(url) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

function getSeoForPath(pathname, ctx = {}) {
  const { selectedDestName, days } = ctx;

  // Default
  let title = "Itinex — Plan less. Explore more.";
  let desc = "Weather-aware travel itineraries built around real attractions.";
  let canonicalPath = pathname;

  // Main pages
  if (pathname === "/destinations") {
    title = "Destinations — Itinex";
    desc = "Browse popular destinations, read reviews, and start planning your trip.";
  } else if (pathname === "/map") {
    title = "Map — Itinex";
    desc = "Explore destinations on an interactive map and plan your trip in minutes.";
  } else if (pathname === "/saved") {
    title = "Saved Trips — Itinex";
    desc = "Reopen and manage your saved itineraries on this device.";
  }

  // Planner flow (optional routes you added)
  else if (pathname === "/planner/dates") {
    title = "Choose dates — Itinex";
    desc = "Select your trip dates and preferences to generate a smarter itinerary.";
  } else if (pathname === "/planner/itinerary") {
    title = selectedDestName
      ? `${days || ""}-day itinerary for ${selectedDestName} — Itinex`.replace(" -day", "-day")
      : "Your itinerary — Itinex";
    desc = selectedDestName
      ? `Your weather-aware itinerary for ${selectedDestName}. Save, share, and collaborate live.`
      : "Your weather-aware itinerary. Save, share, and collaborate live.";
  }

  // Footer pages
  else if (pathname === "/about") {
    title = "About — Itinex";
    desc = "Learn how Itinex helps travelers plan better trips with weather-aware itineraries and real places.";
  } else if (pathname === "/contact") {
    title = "Contact — Itinex";
    desc = "Contact the Itinex team for support, feedback, or partnership enquiries.";
  } else if (pathname === "/advertise") {
    title = "Advertise — Itinex";
    desc = "Reach high-intent travelers while they plan. Explore advertising opportunities with Itinex.";
  } else if (pathname === "/privacy") {
    title = "Privacy Policy — Itinex";
    desc = "How Itinex collects, uses, and protects your information.";
  } else if (pathname === "/terms") {
    title = "Terms of Service — Itinex";
    desc = "Terms and conditions for using Itinex.";
  }

  // In case someone lands on unknown route
  else {
    canonicalPath = "/";
  }

  return { title, desc, canonicalPath };
}


function DestinationLeafletPicker({ destinations, onPick }) {
  // Default center (will be overridden by FitBounds)
  const center = [20, 0];

  return (
    <div className="bg-white rounded-2xl shadow-xl p-6">
      <div className="flex items-center justify-between gap-3 mb-4 flex-wrap">
        <div>
          <h3 className="text-lg font-bold text-gray-900">Pick from map</h3>
          <p className="text-sm text-gray-600">Hover a marker to see the destination, click to select.</p>
        </div>
        <div className="text-xs text-gray-500">Zoom + drag to explore</div>
      </div>

      <div className="overflow-hidden rounded-2xl border">
        <div style={{ height: 520, width: '100%' }}>
          <MapContainer
            center={center}
            zoom={2}
            scrollWheelZoom
            style={{ height: '100%', width: '100%' }}
          >
            <TileLayer
              // Free OpenStreetMap tiles
              attribution='&copy; OpenStreetMap contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            <FitBounds destinations={destinations} />

            {destinations.map((d) => (
              <Marker
                key={d.id}
                position={[d.lat, d.lon]}
                eventHandlers={{
                  click: () => onPick(d),
                }}
              >
                <Tooltip direction="top" offset={[0, -10]} opacity={1} sticky>
                  <div className="font-semibold">{d.name}</div>
                </Tooltip>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </div>

      <div className="mt-3 text-xs text-gray-500">
        Tip: You can still switch back to Grid view anytime.
      </div>
    </div>
  );
}

function getLocalVote(tripId, attractionKey) {
  const k = `itinex:vote:${tripId}:${attractionKey}`;
  const v = localStorage.getItem(k);
  return v ? parseInt(v, 10) : 0; // -1, 0, 1
}

function setLocalVote(tripId, attractionKey, vote) {
  const k = `itinex:vote:${tripId}:${attractionKey}`;
  if (vote === 0) localStorage.removeItem(k);
  else localStorage.setItem(k, String(vote));
}

async function voteAttraction(attractionName, requestedVote /* 1 or -1 */) {
  if (!selectedDest || !attractionName) return;

  const tripId = roomId || `local-${destKey(selectedDest)}`;
  const aKey = buildAttractionKey(selectedDest?.name, attractionName);

  const prev = getLocalVote(tripId, aKey);                   // -1/0/1
  const next = prev === requestedVote ? 0 : requestedVote;   // toggle off

  let likeDelta = 0;
  let dislikeDelta = 0;

  // remove prev
  if (prev === 1) likeDelta -= 1;
  if (prev === -1) dislikeDelta -= 1;

  // apply next
  if (next === 1) likeDelta += 1;
  if (next === -1) dislikeDelta += 1;

  const { data, error } = await supabase.rpc("vote_attraction_delta", {
    p_trip_id: tripId,
    p_attraction_key: aKey,
    p_attraction_name: attractionName,
    p_like_delta: likeDelta,
    p_dislike_delta: dislikeDelta,
  });

  if (error) {
    console.error("vote_attraction_delta failed:", error);
    return;
  }

  setLocalVote(tripId, aKey, next);

  // Update UI with Supabase totals
  setVoteTotals((prevMap) => ({
    ...prevMap,
    [data.attraction_key]: {
      likes: data.likes ?? 0,
      dislikes: data.dislikes ?? 0,
      reactions: data.reactions ?? 0, // total likes+dislikes
    },
  }));
}

async function fetchWikipediaThumbnail(title, size = 1000) {
  if (!title) return null;

  const url =
    `https://en.wikipedia.org/w/api.php?action=query&format=json&origin=*` +
    `&prop=pageimages&piprop=thumbnail&pithumbsize=${size}` +
    `&titles=${encodeURIComponent(title)}`;

  const res = await fetch(url);
  if (!res.ok) return null;

  const data = await res.json();
  const pages = data?.query?.pages;
  if (!pages) return null;

  const firstPage = pages[Object.keys(pages)[0]];
  return firstPage?.thumbnail?.source || null;
}

let _unsplashBlocked = false;

const getUnsplashKey = () =>
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_UNSPLASH_ACCESS_KEY) ||
  process.env.REACT_APP_UNSPLASH_ACCESS_KEY ||
  null;

const fetchUnsplashPhotoUrl = async (query) => {
  if (_unsplashBlocked) return null;

  const key = getUnsplashKey();
  if (!key) return null;

  const url =
    `https://api.unsplash.com/search/photos?per_page=1&orientation=landscape` +
    `&query=${encodeURIComponent(query)}`;

  const res = await fetch(url, {
    headers: {
      Authorization: `Client-ID ${key}`,
      // harmless but sometimes recommended
      "Accept-Version": "v1"
    }
  });

  if (res.status === 403) {
    // log body once so you can confirm "rate limit exceeded"
    let body = "";
    try { body = await res.text(); } catch {}
    console.warn("Unsplash 403 (likely rate limit). Disabling Unsplash for this session.", {
      remaining: res.headers.get("x-ratelimit-remaining"),
      limit: res.headers.get("x-ratelimit-limit"),
      body: body?.slice?.(0, 300)
    });
    _unsplashBlocked = true;
    return null;
  }

  if (!res.ok) return null;

  const data = await res.json();
  return data?.results?.[0]?.urls?.regular || null;
};

const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

const getAttractionImage = async (destinationName, attractionName) => {
  const dest = destinationName || "";
  const att = attractionName || "";
  const cacheKey = `${dest}||${att}`.toLowerCase();

  if (_attractionImageCache.has(cacheKey)) return _attractionImageCache.get(cacheKey);

  // 1) Wikipedia thumbnail (usually the most "exact")
  const wikiImg = await fetchWikipediaThumbnail(att, 1000);
  if (wikiImg) {
    _attractionImageCache.set(cacheKey, wikiImg);
    return wikiImg;
  }

  // 2) Unsplash fallback (can be rate-limited; now handled)
  const unsplashImg = await fetchUnsplashPhotoUrl(`${att} ${dest}`);
  const finalUrl = unsplashImg || svgPlaceholderDataUrl(att);

  _attractionImageCache.set(cacheKey, finalUrl);
  return finalUrl;
};

const hydrateAttractionImages = async (destinationName, plan) => {
  const names = new Set();
  plan.forEach((d) => {
    if (d.morning) names.add(d.morning);
    if (d.evening) names.add(d.evening);
  });

  const updates = {};
  for (const name of names) {
    updates[name] = await getAttractionImage(destinationName, name);
  }

  setAttractionImages((prev) => ({ ...prev, ...updates }));
};


  const fetchDestinations = React.useCallback(async () => {
  setLoadingDests(true);
  setError(null);

  try {
    const res = await fetch('/destinations.json');
    if (!res.ok) throw new Error('Failed to fetch destinations.json');
    const popularCities = await res.json();


const destinationsWithImages = await Promise.all(
  popularCities.map(async (city, index) => {
    const label = `${city.name}, ${city.country}`;
    const query = `${city.name} ${city.country} landmark`;
    const image = (await fetchUnsplashImage(query)) || svgPlaceholderDataUrl(label);

    return {
      id: index + 1,
      name: label,
      cityName: city.name,                 // ✅ ADD (for clean slugs)
      country: city.country,
      lat: city.lat,
      lon: city.lon,
      iata: city.iata || null,
      image,
      slug: slugify(`${city.name}-${city.country}`), // ✅ ADD
    };
  })
);


    setDestinations(destinationsWithImages);
  } catch (e) {
    setError('Failed to load destinations. Please refresh the page.');
  } finally {
    setLoadingDests(false);
  }
}, []);

// Keyword arrays for cost estimation
const expensiveKeywords = [
  'Luxury',
  'Fine Dining',
  'Cruise',
  'Concert',
  'Spa',
  'Resort',
  'Gourmet',
  'Private Tour',
  'Opera',
  'Theater',
  'Premium',
  'VIP',
  'Helicopter',
  'Yacht',
  'Casino',
  'High-end'
];

const mediumKeywords = [
  'Museum',
  'Aquarium',
  'Science',
  'Castle',
  'Observation',
  'Gallery',
  'Historic',
  'Botanical',
  'Zoo',
  'Planetarium',
  'Workshop',
  'Exhibit',
  'Monument',
  'Tower',
  'Park',
  'Temple'
];

/**
 * Determine cost level (1-5 💵) based on title and description
 */
const getCostLevel = (title = '', description = '') => {
  const text = `${title} ${description}`.toLowerCase();

  // Check expensive keywords
  if (expensiveKeywords.some((kw) => text.includes(kw.toLowerCase()))) return 5;

  // Check medium keywords
  if (mediumKeywords.some((kw) => text.includes(kw.toLowerCase()))) return 3;

  // Default cheap
  return 1;
};


const UNSPLASH_KEY = process.env.REACT_APP_UNSPLASH_ACCESS_KEY;

  useEffect(() => {
  fetchDestinations();
  loadDestinationReviews();
}, [fetchDestinations]);

useEffect(() => {
  // ✅ Destination SEO pages: /destinations/:slug
  if (location.pathname.startsWith("/destinations/") && selectedDest) {
    const title = `${selectedDest.cityName || selectedDest.name} Trip Planner — Itinex`;
    const desc = `Plan a ${days || 3}-day trip to ${
      selectedDest.cityName || selectedDest.name
    }. Build a weather-aware itinerary with real attractions, maps, and saving.`;

    document.title = title;
    upsertMeta("description", desc);
    upsertMeta("og:title", title, true);
    upsertMeta("og:description", desc, true);
    setCanonical(window.location.origin + location.pathname);
    return;
  }

  // ✅ Default / planner pages
  const title =
    step === "itinerary" && selectedDest?.name
      ? `Itinex — ${selectedDest.name} (${days} days)`
      : "Itinex — plan less, explore more";

  document.title = title;

  const desc =
    step === "itinerary" && selectedDest?.name
      ? `Your weather-aware itinerary for ${selectedDest.name}. Save, share, and collaborate.`
      : "Weather-aware itineraries and real places for your next trip.";

  upsertMeta("description", desc);
  upsertMeta("og:title", title, true);
  upsertMeta("og:description", desc, true);

  setCanonical(window.location.origin + location.pathname);
}, [location.pathname, step, selectedDest?.name, days]);


  const loadDestinationReviews = async () => {
  try {
    const { data, error } = await supabase
      .from("reviews")
      .select("id,destination_id,destination_name,author,text,rating,created_at")
      .order("created_at", { ascending: false });

    if (error) throw error;

    const grouped = {};
    for (const r of data || []) {
      if (!grouped[r.destination_id]) grouped[r.destination_id] = [];
      grouped[r.destination_id].push({
        id: r.id,
        destinationId: r.destination_id,
        destinationName: r.destination_name,
        author: r.author,
        text: r.text,
        rating: r.rating,
        ts: new Date(r.created_at).getTime(),
      });
    }
    setDestinationReviews(grouped);
  } catch (err) {
    console.error("Failed to load reviews:", err);
    // keep app usable even if reviews fail
  }
};


  const addDestinationReview = async () => {
  if (!reviewText.trim() || !selectedReviewDest) return;

  const destinationId = destKey(selectedReviewDest);

  try {
    const payload = {
      destination_id: destinationId,
      destination_name: selectedReviewDest.name,
      author: reviewName.trim() || "Anonymous",
      text: reviewText.trim(),
      rating: reviewRating,
    };

    const { data, error } = await supabase
      .from("reviews")
      .insert(payload)
      .select("id,destination_id,destination_name,author,text,rating,created_at")
      .single();

    if (error) throw error;

    const normalized = {
      id: data.id,
      destinationId: data.destination_id,
      destinationName: data.destination_name,
      author: data.author,
      text: data.text,
      rating: data.rating,
      ts: new Date(data.created_at).getTime(),
    };

    setDestinationReviews((prev) => ({
      ...prev,
      [destinationId]: [normalized, ...(prev[destinationId] || [])],
    }));

    setReviewText("");
    setReviewRating(5);
    setReviewName("");
  } catch (err) {
    console.error(err);
    setError("Failed to save review. Please try again.");
  }
};



  const getAverageRating = (destKeyId) => {
  const reviews = destinationReviews[destKeyId] || [];
  if (!reviews.length) return 0;
  const sum = reviews.reduce((acc, r) => acc + r.rating, 0);
  return (sum / reviews.length).toFixed(1);
};


  const openReviewModal = (dest) => {
  setSelectedReviewDest(dest);
  setShowReviews(true);

  const key = destKey(dest);
  fetchReviewsForDestination(key);
};


  const fetchAttractions = async (lat, lon, destinationFullName) => {
  const key = slugify(destinationFullName); // e.g. london-united-kingdom

  // 1) Curated per-destination attractions (best quality)
  const curated = attractionsMap?.[key];
  if (
    curated?.sunny?.length &&
    curated?.cloudy?.length &&
    curated?.rainy?.length
  ) {
    setAttractionsSource('curated');
    return curated;
  }

  // 2) Wikipedia nearby attractions (real places near coordinates)
  try {
    const attractions = await fetchWikipediaAttractions(lat, lon);
    if (attractions?.sunny?.length > 8) {
      setAttractionsSource('wikipedia');
      return attractions;
    }
  } catch {}

  // 3) Last-resort generic fallback
  setAttractionsSource('fallback');
  return getCuratedAttractions(destinationFullName || '');
};



  const fetchWikipediaAttractions = async (lat, lon) => {
  // 1) Get nearby pages
  const geoRes = await fetch(
    `https://en.wikipedia.org/w/api.php?action=query&list=geosearch&gsradius=50000&gscoord=${lat}|${lon}&gslimit=50&format=json&origin=*`
  );
  const geoData = await geoRes.json();
  const geo = geoData?.query?.geosearch || [];
  if (geo.length < 12) throw new Error('Not enough nearby Wikipedia places');

  // 2) Pull more details for those pages (title + short description/extract)
  const pageIds = geo.map(p => p.pageid).slice(0, 30).join('|');
  const detailRes = await fetch(
    `https://en.wikipedia.org/w/api.php?action=query&pageids=${pageIds}&prop=pageprops|description|extracts&exintro=1&explaintext=1&format=json&origin=*`
  );
  const detailData = await detailRes.json();
  const pages = detailData?.query?.pages || {};

  const badWords = [
    'station', 'district', 'constituency', 'railway', 'school',
    'hospital', 'road', 'street', 'avenue', 'university', 'college',
    'cemetery', 'company', 'office', 'neighborhood'
  ];

  const places = geo
    .map((g) => {
      const page = pages[String(g.pageid)] || {};
      const title = g.title || '';
      const desc = (page.description || '').toLowerCase();
      const extract = (page.extract || '').toLowerCase();
      return {
        name: title,
        distance: g.dist,
        // rough text signals to help categorization
        text: `${desc} ${extract}`.trim()
      };
    })
    .filter((p) => {
      const t = p.name.toLowerCase();
      if (!p.name || p.name.length > 60) return false;
      if (badWords.some(w => t.includes(w))) return false;
      // also avoid purely administrative pages
      if (p.text.includes('administrative')) return false;
      return true;
    });

  if (places.length < 12) throw new Error('Not enough good Wikipedia places');

  return categorizeAttractions(places);
};

  const fetchWeather = async (destination) => {
    setLoading(true);
    setError(null);

    if (weatherAbortRef.current) weatherAbortRef.current.abort();
    const controller = new AbortController();
    weatherAbortRef.current = controller;

    try {
      const attractions = await fetchAttractions(destination.lat, destination.lon, destination.name);

     const dailyFields =
  "weather_code,temperature_2m_max,temperature_2m_min,precipitation_sum,precipitation_probability_max,wind_speed_10m_max,sunrise,sunset";
const todayStr = new Date().toISOString().slice(0, 10);

if (useDateRange && startDate && endDate) {
  if (startDate < todayStr) {
    setLoading(false);
    setError("Start date can’t be in the past (forecast API).");
    return;
  }

  const d = daysFromRange(startDate, endDate);
  if (d > 14) { // your UI says max 14 anyway
    setLoading(false);
    setError("Please select a date range of 14 days or less.");
    return;
  }
}

let weatherUrl = `https://api.open-meteo.com/v1/forecast?latitude=${destination.lat}&longitude=${destination.lon}&daily=${dailyFields}&timezone=auto`;

if (useDateRange && startDate && endDate) {
  weatherUrl += `&start_date=${startDate}&end_date=${endDate}`;
} else {
  weatherUrl += `&forecast_days=${days}`;
}

const response = await fetch(weatherUrl, { signal: controller.signal });

      if (!response.ok) throw new Error(`Weather API error: ${response.status}`);

      const data = await response.json();
      if (!data.daily?.weather_code) throw new Error('Invalid weather data format');

      setWeather(data);
      const { plan, normalizedAttractions } = generateItinerary({
        weatherData: data,
        destination,
        attractionsData: attractions,
        days,
        useDateRange,
        startDate,
        getWeatherCondition,
        hiddenGemsMode,
        surpriseLevel,
      });

      setAttractionsForTrip(normalizedAttractions);
      setItinerary(plan);
      setStep("itinerary");
      navigate("/planner/itinerary");
      setViewMode("itinerary"); 
      setLoading(false);
      hydrateAttractionImages(destination?.name || "", plan);
    } catch (e) {
  if (e?.name === "AbortError") return;

  console.error("Weather fetch failed:", e);

  try {
    const attractions = await fetchAttractions(
      destination.lat,
      destination.lon,
      destination.name
    );

    // Use itinerary defaults if weather fails (weatherData can be null)
    const { plan, normalizedAttractions } = generateItinerary({
      weatherData: null,                 // ✅ allowed by your generator
      destination,
      attractionsData: attractions,
      days,
      useDateRange,
      startDate,
      getWeatherCondition,
        hiddenGemsMode,
        surpriseLevel,
    });

    setAttractionsForTrip(normalizedAttractions);
    setItinerary(plan);
    setStep("itinerary");
    setError("Weather unavailable — generated itinerary with default conditions.");
    hydrateAttractionImages(destination?.name || "", plan);
  } catch (err2) {
    console.error("Fallback itinerary generation failed:", err2);
    setError("Failed to generate itinerary. Please try again.");
  } finally {
    setLoading(false);
  }
}


  };

  const getWeatherIcon = (code) => {
    if (code === 0 || code === 1) return <Sun className="w-6 h-6 text-yellow-500" />;
    if (code === 2 || code === 3) return <Cloud className="w-6 h-6 text-gray-500" />;
    return <CloudRain className="w-6 h-6 text-blue-500" />;
  };

  const handleSelectDestination = (dest) => {
  setSelectedDest(dest);

  // ✅ go to SEO-friendly destination URL
  navigate(`/destinations/${dest.slug}`);

  // ✅ show date picker UI
  setStep("days");

  window.scrollTo(0, 0);
};


  const handlePlanTrip = () => {
    fetchWeather(selectedDest);
  };

const e = new Date();
  const resetPlanner = () => {
    if (weatherAbortRef.current) weatherAbortRef.current.abort();

setUseDateRange(true);
setStartDate(new Date().toISOString().slice(0, 10));
e.setDate(e.getDate() + 2);
setEndDate(e.toISOString().slice(0, 10));

setAttractionsSource(null);
setAttractionsForTrip(null);

    setStep('select');
    setSelectedDest(null);
    setDays(3);
    setWeather(null);
    setItinerary([]);
    setError(null);
    setShareUrl('');
    setRoomId('');
    setPresenceCount(1);
    setComments([]);
    safeDestroyCollab();
  };



const FooterLink = ({ label, nav }) => {
  const pathMap = {
    destinations: "/destinations",
    map: "/map",
    saved: "/saved",
    about: "/about",
    contact: "/contact",
    advertise: "/advertise",
    privacy: "/privacy",
    terms: "/terms",
  };

  return (
    <Link
      to={pathMap[nav]}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="text-slate-600 hover:text-itinex-primary hover:underline text-left"
    >
      {label}
    </Link>
  );
};
const pickReplacement = (slot, dayObj, currentItinerary) => {
  const pools = attractionsForTrip;
  if (!pools) return null;

  const used = new Set();
  currentItinerary.forEach((d) => {
    if (d.morning) used.add(d.morning);
    if (d.evening) used.add(d.evening);
  });

  const currentValue = slot === 'morning' ? dayObj.morning : dayObj.evening;
  used.delete(currentValue); // allow replacing current one

  const preferred = pools[dayObj.condition] || [];
  const alternatives = ['sunny', 'cloudy', 'rainy'].filter((c) => c !== dayObj.condition);

  const candidates = [
    ...preferred,
    ...alternatives.flatMap((c) => pools[c] || [])
  ].filter((name) => name && !used.has(name) && name !== currentValue);

  if (candidates.length === 0) return null;

  return candidates[Math.floor(Math.random() * candidates.length)];
};

const swapWithNearbyPlace = (newPlace) => {
  if (!activePlace) return;

  setItinerary((prev) => {
    let targetDayIndex = -1;
    let targetSlot = null;

    // locate the active place
    prev.forEach((day, idx) => {
      if (day.morning === activePlace) {
        targetDayIndex = idx;
        targetSlot = 'morning';
      }
      if (day.evening === activePlace) {
        targetDayIndex = idx;
        targetSlot = 'evening';
      }
    });

    if (targetDayIndex === -1) return prev;

    // collect used places (excluding the active one)
    const used = new Set();
    prev.forEach((d) => {
      if (d.morning) used.add(d.morning);
      if (d.evening) used.add(d.evening);
    });
    used.delete(activePlace);

    // hard block: no duplicates elsewhere
    if (used.has(newPlace)) {
      return prev;
    }

    // 🔍 check adjacent days
    const prevDay = prev[targetDayIndex - 1];
    const nextDay = prev[targetDayIndex + 1];

    const usedAdjacent =
      prevDay?.morning === newPlace ||
      prevDay?.evening === newPlace ||
      nextDay?.morning === newPlace ||
      nextDay?.evening === newPlace;

    // soft preference: only block if we *have* better options
    if (usedAdjacent) {
      const hasNonAdjacentOption = nearbyPlaces?.some((p) => {
        if (p === newPlace || used.has(p)) return false;

        return !(
          prevDay?.morning === p ||
          prevDay?.evening === p ||
          nextDay?.morning === p ||
          nextDay?.evening === p
        );
      });

      if (hasNonAdjacentOption) {
        return prev;
      }
    }

    return prev.map((day, idx) => {
      if (idx !== targetDayIndex) return day;
      return { ...day, [targetSlot]: newPlace };
    });
  });

  // 🔹 auto-hydrate image (async, safe)
  try {
    const destName = selectedDest?.name || '';
    Promise.resolve(getAttractionImage(destName, newPlace)).then((url) => {
      if (!url) return;
      setAttractionImages((prev) => ({
        ...prev,
        [newPlace]: url,
      }));
    });
  } catch {}

  setPlaceModalOpen(false);
};



const replaceActivityForDay = async (dayNumber, slot) => {
  setItinerary((prev) => {
    const dayObj = prev.find((d) => d.day === dayNumber);
    if (!dayObj) return prev;

    const replacement = pickReplacement(slot, dayObj, prev);
    if (!replacement) {
      setError('No more unique attractions available to replace.');
      return prev;
    }

    // hydrate image in background (safe; if it fails it falls back)
    try {
      const destName = selectedDest?.name || '';
      // If you have getAttractionImage()/hydrateAttractionImages, use that:
      Promise.resolve(getAttractionImage(destName, replacement)).then((url) => {
        if (!url) return;
        setAttractionImages((imgPrev) => ({ ...imgPrev, [replacement]: url }));
      });
    } catch {}

    return prev.map((d) => {
      if (d.day !== dayNumber) return d;
      return {
        ...d,
        [slot]: replacement
      };
    });
  });
};

const swapActivitiesForDay = (dayNumber) => {
  setItinerary((prev) =>
    prev.map((d) => {
      if (d.day !== dayNumber) return d;
      return {
        ...d,
        morning: d.evening,
        evening: d.morning
      };
    })
  );
};

useEffect(() => {
  if (viewMode !== "story") return;
  if (!itinerary?.length) return;

  let cancelled = false;

  (async () => {
    setLoadingStory(true);

    // collect unique places from itinerary
    const names = new Set();
    itinerary.forEach((d) => {
      if (d.morning) names.add(d.morning);
      if (d.evening) names.add(d.evening);
    });

    // fetch only missing ones
    const toFetch = Array.from(names).filter((n) => !storySummaries[n]);

    // light concurrency (avoid hammering)
    const limit = 4;
    let idx = 0;
    const updates = {};

    const worker = async () => {
      while (idx < toFetch.length && !cancelled) {
        const name = toFetch[idx++];
        const s = await fetchWikiSummary(name);
        if (s) updates[name] = s;
      }
    };

    await Promise.all(Array.from({ length: limit }, worker));

    if (!cancelled && Object.keys(updates).length) {
      setStorySummaries((prev) => ({ ...prev, ...updates }));
    }

    if (!cancelled) setLoadingStory(false);
  })();

  return () => {
    cancelled = true;
  };
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [viewMode, itinerary]);

  const buildShareUrl = (payload) => {
    const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
    const url = new URL(window.location.href);
    url.searchParams.set('trip', encoded);
    return url.toString();
  };
  useEffect(() => {
  if (!useDateRange) return;
  const d = daysFromRange(startDate, endDate);
  setDays(Math.max(1, Math.min(14, d)));
}, [useDateRange, startDate, endDate]);

useEffect(() => {
  if (step !== "itinerary" || !selectedDest) return;

  const tripId = roomId || `local-${destKey(selectedDest)}`;

  (async () => {
    const { data, error } = await supabase
      .from("attraction_votes")
      .select("attraction_key, likes, dislikes, reactions")
      .eq("trip_id", tripId);

    if (error) {
      console.error("Failed to load votes:", error);
      return;
    }

    const map = {};
    (data || []).forEach((r) => {
      map[r.attraction_key] = {
        likes: r.likes ?? 0,
        dislikes: r.dislikes ?? 0,
        reactions: r.reactions ?? 0,
      };
    });

    setVoteTotals(map);
  })();
}, [step, roomId, selectedDest]);

  useEffect(() => {
  if (step !== 'itinerary' || !selectedDest || itinerary.length === 0) return;

  const url = buildShareUrl({
    selectedDest,
    days,
    weather,
    itinerary,
    useDateRange,
    startDate,
    endDate,
    viewMode,
    budgetData,
    currency,
  });

  setShareUrl(url);
}, [step, selectedDest, days, weather, itinerary, useDateRange, startDate, endDate]);


  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
  };

  const handleWebShare = async () => {
    if (!shareUrl) return;
    if (navigator.share) {
      try {
        await navigator.share({
          title: `Holiday Planner — ${selectedDest?.name}`,
          text: 'Join my trip plan and collaborate in real time!',
          url: shareUrl
        });
        return;
      } catch {}
    }
    await copyToClipboard(shareUrl);
    setError('Share link copied to clipboard.');
  };

  const skyscannerUrl = useMemo(() => {
    return buildSkyscannerFlightsUrl({
      destinationIata: selectedDest?.iata,
      outboundIso: useDateRange ? startDate : null,
      inboundIso: useDateRange ? endDate : null
    });
  }, [selectedDest?.iata, useDateRange, startDate, endDate]);

  const socialShareLinks = useMemo(() => {
    const u = encodeURIComponent(shareUrl || window.location.href);
    const text = encodeURIComponent(`Join my holiday plan: ${selectedDest?.name || ''}`);
    return {
      x: `https://twitter.com/intent/tweet?url=${u}&text=${text}`,
      whatsapp: `https://wa.me/?text=${text}%20${u}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`
    };
  }, [shareUrl, selectedDest?.name]);

  const generateIcs = () => {
  const dtstamp = formatIcsDate(new Date());

  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Itinex//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH'
  ];

  itinerary.forEach((d) => {
    // Prefer isoDate from itinerary; fallback to startDate + day index
    let base = null;

    if (d.isoDate) {
      base = new Date(`${d.isoDate}T00:00:00`);
    } else if (useDateRange && startDate) {
      const sd = new Date(`${startDate}T00:00:00`);
      base = new Date(sd.getTime() + (d.day - 1) * 86400000);
    } else {
      // absolute fallback: today + index
      const t = new Date();
      t.setHours(0, 0, 0, 0);
      base = new Date(t.getTime() + (d.day - 1) * 86400000);
    }

    // Morning 09:00–13:00
    const morningStart = new Date(base);
    morningStart.setHours(9, 0, 0, 0);
    const morningEnd = new Date(morningStart.getTime() + 4 * 60 * 60 * 1000);

    lines.push(
      ...icsEventLines({
        uid: cryptoRandomId(),
        dtstamp,
        start: morningStart,
        end: morningEnd,
        summary: `Morning: ${d.morning}`,
        description: `Destination: ${selectedDest?.name}\nWeather: ${d.condition}, High ${d.tempMax ?? d.temp ?? ''}°C / Low ${d.tempMin ?? ''}°C`,
        location: selectedDest?.name || ''
      })
    );

    // Evening 16:00–20:00
    const eveStart = new Date(base);
    eveStart.setHours(16, 0, 0, 0);
    const eveEnd = new Date(eveStart.getTime() + 4 * 60 * 60 * 1000);

    lines.push(
      ...icsEventLines({
        uid: cryptoRandomId(),
        dtstamp,
        start: eveStart,
        end: eveEnd,
        summary: `Evening: ${d.evening}`,
        description: `Destination: ${selectedDest?.name}\nWeather: ${d.condition}, High ${d.tempMax ?? d.temp ?? ''}°C / Low ${d.tempMin ?? ''}°C`,
        location: selectedDest?.name || ''
      })
    );
  });

  lines.push('END:VCALENDAR');
  return lines.join('\r\n');
};

const rangeLine =
  useDateRange && startDate && endDate
    ? `Dates: ${startDate} → ${endDate}\n`
    : '';
  const downloadIcs = () => {
    const ics = generateIcs();
    const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `itinerary-${slugify(selectedDest?.name || 'trip')}.ics`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const emailItinerary = () => {
  const subject = `Holiday itinerary: ${selectedDest?.name}`;

  const body = [
  `Hi!`,
  ``,
  `Here's the holiday itinerary for ${selectedDest?.name}:`,
  rangeLine,
  shareUrl ? `\nShared plan link (collaborate live):\n${shareUrl}\n` : '',
  `Summary:`,
    ...itinerary.map(
      (d) =>
        `Day ${d.day} (${d.date}) — Morning: ${d.morning} | Evening: ${d.evening} — ${d.condition}, High ${d.tempMax}°C / Low ${d.tempMin}°C`
    ),
    '',
    'Cheers!'
  ].join('\n');

  const mailto = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = mailto;
};


  const exportToPdf = async () => {
    if (!pdfRef.current) return;
    setExportingPdf(true);
    setError(null);

    try {
      await waitForImages(pdfRef.current);

      const canvas = await html2canvas(pdfRef.current, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff'
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'pt', 'a4');

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = position - pageHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`itinerary-${slugify(selectedDest?.name || 'trip')}.pdf`);
    } catch (e) {
      setError(`PDF export failed: ${e?.message || 'unknown error'}`);
    } finally {
      setExportingPdf(false);
    }
  };

  const addCommentLocalAndCollaborative = async () => {
    if (!commentText.trim()) return;
    addCommentViaSingleton(commentName || 'Anonymous', commentText.trim(), setComments);
    setCommentText('');
  };

  useEffect(() => {
  if (step !== 'itinerary' || itinerary.length === 0 || !roomId) return;
ensureCollabSingleton(roomId, commentName || 'Anonymous', setComments, setPresenceCount, setVotes);
  return () => safeDestroyCollab();
}, [step, roomId, commentName, itinerary.length]);


  if (loadingDests) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-itinex-secondary via-indigo-50 to-itinex-primary flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Loading amazing destinations...</p>
        </div>
      </div>
    );
  }

function SkyscannerHeaderButton({ href, label = "Flights", disabled = false }) {
  return (
    <a
      href={href || "#"}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => {
        // prevent navigation if disabled / missing url
        if (disabled || !href) {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
      className={[
        "inline-flex items-center gap-2 px-4 py-2 rounded-lg text-white font-semibold",
        "shadow-sm transition hover:opacity-95",
        disabled || !href ? "opacity-50 cursor-not-allowed pointer-events-none" : "",
      ].join(" ")}
      style={{ backgroundColor: "#00A3E0" }} // Skyscanner blue
      title="Open Skyscanner"
    >
      {/* You already import LinkIcon; you can swap to Plane icon if you want */}
      <LinkIcon className="w-4 h-4" />
      {label}
    </a>
  );
}

function getLocalVote(tripId, k) {
  const key = `itinex:vote:${tripId}:${k}`;
  const v = localStorage.getItem(key);
  return v ? parseInt(v, 10) : 0; // -1/0/1
}

function setLocalVote(tripId, k, vote) {
  const key = `itinex:vote:${tripId}:${k}`;
  if (vote === 0) localStorage.removeItem(key);
  else localStorage.setItem(key, String(vote));
}

async function applyVote(k, delta) {
  try {
    if (!selectedDest) return;

    const tripId = roomId || `local-${destKey(selectedDest)}`;

    // toggle per browser
    const prev = getLocalVote(tripId, k);
    const next = prev === delta ? 0 : delta;

    let likeDelta = 0;
    let dislikeDelta = 0;

    // remove prev
    if (prev === 1) likeDelta -= 1;
    if (prev === -1) dislikeDelta -= 1;

    // add next
    if (next === 1) likeDelta += 1;
    if (next === -1) dislikeDelta += 1;

    // attraction name from key
    const attractionName = (k.split("::")[1] || "").replace(/-/g, " ");

    console.log("applyVote()", { tripId, k, attractionName, likeDelta, dislikeDelta });

    const { data, error } = await supabase.rpc("vote_attraction_delta", {
      p_trip_id: tripId,
      p_attraction_key: k,
      p_attraction_name: attractionName,
      p_like_delta: likeDelta,
      p_dislike_delta: dislikeDelta,
    });

    if (error) {
      console.error("Supabase RPC error:", error);
      setError?.(`Vote save failed: ${error.message}`);
      return;
    }

    console.log("RPC OK:", data);

    setLocalVote(tripId, k, next);

    // update UI immediately from returned row
    setVoteTotals((prevMap) => ({
      ...prevMap,
      [k]: {
        likes: data.likes ?? 0,
        dislikes: data.dislikes ?? 0,
        reactions: data.reactions ?? 0,
      },
    }));
  } catch (e) {
    console.error("applyVote exception:", e);
    setError?.(`Vote save failed: ${e.message}`);
  }
}


  function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setOG(property, content) {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function escapeXml(s) {
  return String(s).replace(/[<>&'"]/g, (c) => ({
    "<": "&lt;",
    ">": "&gt;",
    "&": "&amp;",
    "'": "&apos;",
    '"': "&quot;"
  }[c]));
}
const DestinationMapPicker = ({ destinations, onPick }) => {
  const hovered = destinations.find(d => d.id === hoveredDestId);

  return (
    <div className="bg-white rounded-2xl shadow-xl p-6">
      <div className="flex items-center justify-between gap-3 mb-4 flex-wrap">
        <div>
          <h3 className="text-lg font-bold text-gray-900">Pick from map</h3>
          <p className="text-sm text-gray-600">Hover a flag to see the destination, click to select.</p>
        </div>

        {hovered ? (
          <div className="px-3 py-2 rounded-xl border bg-gray-50 text-sm text-gray-800">
            <span className="font-semibold">{hovered.name}</span>
          </div>
        ) : (
          <div className="px-3 py-2 rounded-xl border bg-gray-50 text-sm text-gray-500">
            Hover a marker…
          </div>
        )}
      </div>

      {/* "World map" panel */}
      <div className="relative w-full overflow-hidden rounded-2xl border bg-gradient-to-br from-itinex-secondary via-indigo-50 to-itinex-primary">
        {/* Maintain a nice aspect ratio */}
        <div className="relative w-full" style={{ paddingTop: '52%' }}>
          {/* Subtle grid lines */}
          <div className="absolute inset-0 opacity-30">
            <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(to_bottom,rgba(0,0,0,0.05)_1px,transparent_1px)] bg-[size:40px_40px]" />
          </div>

          {/* Equator + prime meridian */}
          <div className="absolute left-0 right-0 top-1/2 h-px bg-black/10" />
          <div className="absolute top-0 bottom-0 left-1/2 w-px bg-black/10" />

          {/* Markers */}
          {destinations.map((dest) => {
            const { x, y } = latLonToXY(dest.lat, dest.lon);

            return (
              <button
                key={dest.id}
                type="button"
                onMouseEnter={() => setHoveredDestId(dest.id)}
                onMouseLeave={() => setHoveredDestId(null)}
                onFocus={() => setHoveredDestId(dest.id)}
                onBlur={() => setHoveredDestId(null)}
                onClick={() => onPick(dest)}
                className="absolute -translate-x-1/2 -translate-y-1/2 group"
                style={{ left: `${x}%`, top: `${y}%` }}
                aria-label={`Select ${dest.name}`}
                title={dest.name}
              >
                {/* Flag pin */}
                <div className="relative">
                  <div className="w-9 h-9 rounded-full bg-white shadow-md border flex items-center justify-center group-hover:scale-110 transition-transform">
                    <span className="text-lg">📍</span>
                  </div>

                  {/* Tooltip */}
                  <div className="pointer-events-none absolute left-1/2 top-full mt-2 -translate-x-1/2 whitespace-nowrap opacity-0 group-hover:opacity-100 group-focus:opacity-100 transition-opacity">
                    <div className="px-3 py-1 rounded-full bg-gray-900 text-white text-xs shadow">
                      {dest.name}
                    </div>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-4 text-xs text-gray-500">
        Tip: You can still switch back to Grid view anytime.
      </div>
    </div>
  );
};


  return (
    <div className="min-h-screen bg-gradient-to-br from-itinex-secondary via-indigo-50 to-itinex-primary">
      <header className="sticky top-0 z-50 bg-white/85 backdrop-blur border-b border-slate-200">
  <div className="max-w-7xl mx-auto px-4 py-4">
    <div className="flex items-center justify-between gap-3">
      {/* Brand */}
<div
  role="button"
  tabIndex={0}
  onClick={() => {
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }}
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      navigate("/");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }}
  className="flex items-center gap-3 cursor-pointer select-none"
  aria-label="Go to home"
>
  <div className="p-2 rounded-xl bg-gradient-to-br from-itinex-secondary to-itinex-primary shadow-sm">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-map-pin w-5 h-5 text-white"
      aria-hidden="true"
    >
      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  </div>

  <div className="leading-tight">
    <div className="flex items-center gap-2">
      <h1 className="text-xl md:text-2xl font-extrabold text-slate-900">
        Itinex
      </h1>
      <span className="hidden sm:inline text-xs font-semibold px-2 py-0.5 rounded-full border bg-slate-50 text-slate-600">
        Plan less. Explore more.
      </span>
    </div>

    <p className="hidden md:block text-xs text-slate-600">
      Smart itineraries • Real places • Weather-aware planning
    </p>
  </div>
</div>


      {/* Desktop IA nav */}
      <nav className="hidden lg:flex items-center gap-1">
 <NavButton
  active={location.pathname === "/"}
  onClick={() => navigate("/")}
>
  Home
</NavButton>


<NavButton
  active={location.pathname === "/destinations"}
  onClick={() => {
    navigate("/destinations");
    setTimeout(() => scrollToSection("destinations"), 50);
  }}
>
  Destinations
</NavButton>


<NavButton
  active={location.pathname === "/map"}
  onClick={() => {
    navigate("/map");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }}
>
  Map
</NavButton>


<NavButton
  active={location.pathname === "/saved"}
  onClick={() => navigate("/saved")}
>
  Saved Trips
</NavButton>



        {/*<NavButton
          active={activeNav === "reviews"}
          onClick={() => setActiveNav("reviews")}
        >
          Reviews
        </NavButton>*/}
      </nav>

      {/* Right actions */}
      <div className="flex items-center gap-2">
        {step !== "select" && (
          <button
            active={location.pathname === "/destinations"}
            onClick={() => {
              navigate("/destinations");
              setTimeout(() => scrollToSection("destinations"), 50);
            }}
            className="hidden sm:inline-flex items-center gap-2 px-3 py-2 rounded-lg border bg-white hover:bg-slate-50 text-slate-700"
          >
            <ArrowLeft className="w-4 h-4" />
            Start Over
          </button>
        )}

        <button
          active={location.pathname === "/destinations"}
            onClick={() => {
              navigate("/destinations");
              setTimeout(() => scrollToSection("destinations"), 50);
            }}
          className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-lg
                     bg-gradient-to-r from-itinex-secondary to-itinex-primary
                     text-white font-semibold hover:opacity-90 transition"
        >
          <Sparkles className="w-4 h-4" />
          New Trip
        </button>

        {/* Mobile menu toggle */}
        <button
          onClick={() => setMobileNavOpen((v) => !v)}
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-lg border bg-white hover:bg-slate-50"
          aria-label="Open menu"
        >
          <ChevronRight className={`w-5 h-5 text-slate-700 transition-transform ${mobileNavOpen ? "rotate-90" : ""}`} />
        </button>
      </div>
    </div>

   {/* Mobile nav */}
{mobileNavOpen && (
  <div className="lg:hidden mt-4 flex flex-col gap-2">
    
    <MobileNavItem
      onClick={() => {
        setMobileNavOpen(false);
        navigate("/home");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
    >
      Home
    </MobileNavItem>

    {/* Destinations */}
    <MobileNavItem
      onClick={() => {
        setMobileNavOpen(false);
        navigate("/destinations");

        if (step !== "select") resetPlanner();

        setStep("select"); // ✅ REQUIRED
        setTimeout(() => scrollToSection("destinations"), 50);
      }}
    >
      Destinations
    </MobileNavItem>

    {/* Map */}
   <MobileNavItem
      onClick={() => {
        setMobileNavOpen(false);
        navigate("/map");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
    >
      Map
    </MobileNavItem>

    {/* Saved Trips */}
   <MobileNavItem
      onClick={() => {
        setMobileNavOpen(false);
        navigate("/saved");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
    >
      Saved
    </MobileNavItem>

    {/* New Trip */}
    <MobileNavItem
      onClick={() => {
        setMobileNavOpen(false);
        navigate("/destinations");

        if (step !== "select") resetPlanner();

        setStep("select"); // ✅ REQUIRED
        setTimeout(() => scrollToSection("destinations"), 50);
      }}
      className="bg-gradient-to-r from-itinex-secondary to-itinex-primary text-white border-transparent"
    >
      New Trip
    </MobileNavItem>
      </div>
    )}
  </div>
</header>

<div>
{/* This is Default AdSlot
    <div className="bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <AdSlot
          id="ad-top-banner"
          label="Top banner (970×90 / 728×90)"
          className="h-[90px]"
        />
      </div>
    </div>*/}
  {/* SkyScanner Top Ad */}
    <div className="bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <SkyscannerTopAd className="h-[90px]" />
      </div>
    </div>


<div className=""> {/* use "max-w-[1440px] mx-auto px-4 py-8" to squeeze layout */}
  <div className="grid grid-cols-1 xl:grid-cols-[260px_minmax(0,1fr)_260px] gap-6">
    
    <aside className="hidden xl:block" style={{padding: '10px'}}>
      <div className="sticky top-24 space-y-6">
        <AdSlot id="ad-left-1" label="Left rail (300×600)" className="h-[600px]" />
        <AdSlot id="ad-left-2" label="Left rail (300×250)" className="h-[250px]" />
      </div>
    </aside>

    {isDestinationSeoPage && (
  <section className="max-w-4xl mx-auto px-6 py-14">
    <h1 className="text-3xl font-extrabold text-slate-900">
      {seoDest ? `${seoDest.name} Trip Planner` : "Trip Planner"}
    </h1>

    <p className="mt-3 text-slate-700 leading-relaxed">
      {seoDest
        ? `Build a weather-aware itinerary for ${seoDest.name}. Browse top attractions, get a smart day-by-day plan, and save/share your trip.`
        : "Build a weather-aware itinerary. Browse attractions, get a day-by-day plan, and save/share your trip."}
    </p>

    <div className="mt-8 flex flex-wrap gap-3">
      <button
        type="button"
        onClick={() => {
          if (!seoDest) return;
          // ✅ select destination and go to planner dates
          setSelectedDest(seoDest);
          navigate("/planner/dates");
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
        className="px-5 py-3 rounded-xl bg-itinex-primary text-white font-semibold hover:opacity-90"
      >
        Generate itinerary
      </button>

      {/* ✅ Crawlable internal link */}
      <Link
        to="/destinations"
        className="px-5 py-3 rounded-xl border bg-white text-slate-700 font-semibold hover:bg-slate-50"
      >
        Browse all destinations
      </Link>
    </div>

    <div className="mt-12 space-y-10">
      <div>
        <h2 className="text-xl font-bold text-slate-900">Why plan with Itinex?</h2>
        <ul className="mt-3 list-disc pl-6 text-slate-700 space-y-2">
          <li>Weather-aware itinerary suggestions</li>
          <li>Real attractions and hidden gems</li>
          <li>Map view to plan routes</li>
          <li>Save and share your trip plan</li>
        </ul>
      </div>

      <div>
        <h2 className="text-xl font-bold text-slate-900">Popular attractions</h2>
        <p className="mt-2 text-slate-700">
          {seoDest
            ? `Explore top places in ${seoDest.name}, then generate a day-by-day itinerary based on the forecast.`
            : "Explore top places, then generate a day-by-day itinerary based on the forecast."}
        </p>
      </div>

      <div>
        <h2 className="text-xl font-bold text-slate-900">FAQs</h2>
        <div className="mt-4 space-y-4">
          <div className="rounded-xl border bg-white p-4">
            <div className="font-semibold text-slate-900">
              How many days should I plan?
            </div>
            <div className="mt-1 text-sm text-slate-700">
              Most travelers plan 3–5 days, but Itinex supports up to 14 days.
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)}



    <main className="min-w-0">
      <div className="max-w-7xl mx-auto" style={{padding: '10px'}}>
        {error && (
          <div
  role="alert"
  className="
    mb-6 flex items-start gap-3
    rounded-xl border border-sky-300
    bg-sky-50 px-4 py-3
    shadow-sm
  "
>
  <AlertCircle className="w-5 h-5 text-sky-600 mt-0.5 flex-shrink-0" />

  <div className="leading-tight">
    <p className="text-sm text-sky-800 mt-0.5">
      {error}
    </p>
  </div>
</div>

        )}
        {isFooterPage && (
  <>
    {location.pathname === "/about" && (
      <section className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-extrabold mb-4">About Itinex</h1>

        <p className="text-slate-700 leading-relaxed mb-6">
          Itinex is a smart travel planning platform built to help travelers create
          meaningful, realistic itineraries with less effort and better results.
          We combine destination insights, interactive maps, and weather-aware
          planning to deliver trips that actually work in the real world.
        </p>

        <h2 className="text-xl font-bold mb-2">Our Mission</h2>
        <p className="text-slate-700 mb-6">
          Our mission is simple: make trip planning fast, accurate, and enjoyable.
          We want travelers to spend less time researching and more time exploring.
        </p>

        <h2 className="text-xl font-bold mb-2">What Makes Itinex Different</h2>
        <ul className="list-disc pl-6 space-y-2 text-slate-700">
          <li>Weather-aware itinerary suggestions</li>
          <li>Interactive destination maps</li>
          <li>Real-world attraction data</li>
          <li>Easy trip sharing and saving</li>
          <li>Fast, intuitive planning experience</li>
        </ul>
      </section>

    )}

    {location.pathname === "/contact" && (
      <section className="max-w-4xl mx-auto px-6 py-16 relative z-20">
        <h1 className="text-3xl font-extrabold mb-4">Contact Us</h1>

        <p className="text-slate-700 mb-6">
          We’d love to hear from you. Whether you have feedback, feature requests,
          partnership inquiries, or technical questions, our team is here to help.
        </p>

        <div className="space-y-6">
          {/* GENERAL SUPPORT */}
          <div className="rounded-xl border bg-white p-5">
            <h3 className="font-semibold mb-1">General Support</h3>
            <p className="text-slate-600 text-sm mb-3">
              Questions, bug reports, and help using Itinex.
            </p>

            <a
              href="https://mail.google.com/mail/?view=cm&to=buthpur@itinex.net&su=Itinex%20Support&body=Hi%20Itinex%20Team,%0A%0A"
              target="_blank"
              rel="noopener noreferrer"
              className="
                inline-flex items-center gap-2
                px-4 py-2 rounded-md
                bg-itinex-primary text-white text-sm font-semibold
                hover:opacity-95
                transition-all duration-200
                hover:scale-[1.03]
                hover:shadow-[0_0_0_3px_rgba(16,185,129,0.25),0_10px_25px_-10px_rgba(16,185,129,0.6)]
                active:scale-[0.99]
                focus:outline-none focus:ring-2 focus:ring-itinex-primary/60 focus:ring-offset-2
              "
            >
              <Mail className="w-4 h-4" />
              Email Support
            </a>
          </div>

          {/* BUSINESS & PARTNERSHIPS */}
          <div className="rounded-xl border bg-white p-5">
            <h3 className="font-semibold mb-1">Business & Partnerships</h3>
            <p className="text-slate-600 text-sm mb-3">
              Partnerships, integrations, and collaboration proposals.
            </p>

            <a
              href="https://mail.google.com/mail/?view=cm&to=buthpur@itinex.net&su=Partnership%20Inquiry&body=Hi%20Itinex%20Team,%0A%0A"
              target="_blank"
              rel="noopener noreferrer"
              className="
                inline-flex items-center gap-2
                px-4 py-2 rounded-md
                bg-itinex-primary text-white text-sm font-semibold
                hover:opacity-95
                transition-all duration-200
                hover:scale-[1.03]
                hover:shadow-[0_0_0_3px_rgba(16,185,129,0.25),0_10px_25px_-10px_rgba(16,185,129,0.6)]
                active:scale-[0.99]
                focus:outline-none focus:ring-2 focus:ring-itinex-primary/60 focus:ring-offset-2
              "
            >
              <Mail className="w-4 h-4" />
              Contact Partnerships
            </a>
          </div>

          {/* ADVERTISING */}
          <div className="rounded-xl border bg-white p-5">
            <h3 className="font-semibold mb-1">Advertising</h3>
            <p className="text-slate-600 text-sm mb-3">
              Sponsored placements and campaigns for travel audiences.
            </p>

            <a
              href="https://mail.google.com/mail/?view=cm&to=buthpur@itinex.net&su=Advertising%20with%20Itinex&body=Hi%20Itinex%20Team,%0A%0AI%20am%20interested%20in%20advertising%20on%20Itinex."
              target="_blank"
              rel="noopener noreferrer"
              className="
                inline-flex items-center gap-2
                px-4 py-2 rounded-md
                bg-itinex-primary text-white text-sm font-semibold
                hover:opacity-95
                transition-all duration-200
                hover:scale-[1.03]
                hover:shadow-[0_0_0_3px_rgba(16,185,129,0.25),0_10px_25px_-10px_rgba(16,185,129,0.6)]
                active:scale-[0.99]
                focus:outline-none focus:ring-2 focus:ring-itinex-primary/60 focus:ring-offset-2
              "
            >
              <Mail className="w-4 h-4" />
              Advertise with Itinex
            </a>
          </div>
        </div>
      </section>
    )}

    {location.pathname === "/advertise" && (
      <section className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-extrabold mb-4">Advertise With Itinex</h1>

        <p className="text-slate-700 mb-6">
          Reach travelers at the exact moment they are planning their trips.
          Itinex connects brands with high-intent users actively researching destinations,
          accommodations, and activities.
        </p>

        <h2 className="text-xl font-bold mb-3">Why Advertise With Us</h2>

        <ul className="list-disc pl-6 space-y-2 text-slate-700 mb-6">
          <li>Target users by destination and travel interest</li>
          <li>High engagement planning audience</li>
          <li>Native placement options</li>
          <li>Brand-safe travel environment</li>
          <li>Performance-focused campaigns</li>
        </ul>

        <p className="text-slate-700 mb-4">
          Interested in advertising opportunities or partnerships?
        </p>

        <a
        href="https://mail.google.com/mail/?view=cm&to=buthpur@itinex.net&su=Advertising%20with%20Itinex&body=Hi%20Itinex%20Team,%0A%0AI%20am%20interested%20in%20advertising%20on%20Itinex."
        target="_blank"
        rel="noopener noreferrer"
        className="
          inline-flex items-center gap-2
          px-4 py-2 rounded-md
          bg-itinex-primary text-white text-sm font-semibold
          hover:opacity-95
          transition-all duration-200
          hover:scale-[1.03]
          hover:shadow-[0_0_0_3px_rgba(16,185,129,0.25),0_10px_25px_-10px_rgba(16,185,129,0.6)]
          active:scale-[0.99]
          focus:outline-none focus:ring-2 focus:ring-itinex-primary/60 focus:ring-offset-2
        "
      >
        <Mail className="w-4 h-4" />
        Advertise with Itinex
      </a>
      </section>

    )}

    {location.pathname === "/privacy" && (
      <section className="max-w-4xl mx-auto px-6 py-16 text-slate-700">
        <h1 className="text-3xl font-extrabold mb-4">Privacy Policy</h1>

        <p className="mb-4">
          Your privacy is important to us. This Privacy Policy explains how Itinex
          collects, uses, and protects your information.
        </p>

        <h2 className="font-bold mt-6 mb-2">Information We Collect</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Basic usage data (pages visited, features used)</li>
          <li>Saved trips and itinerary preferences</li>
          <li>Device and browser information</li>
        </ul>

        <h2 className="font-bold mt-6 mb-2">How We Use Your Information</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Improve platform performance</li>
          <li>Enhance travel recommendations</li>
          <li>Provide customer support</li>
          <li>Maintain platform security</li>
        </ul>

        <h2 className="font-bold mt-6 mb-2">Data Protection</h2>
        <p>
          We implement industry-standard security measures to protect your data.
          We do not sell personal user information to third parties.
        </p>

        <p className="mt-6 text-sm text-slate-500">
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </section>

    )}

    {location.pathname === "/terms" && (
      <section className="max-w-4xl mx-auto px-6 py-16 text-slate-700">
        <h1 className="text-3xl font-extrabold mb-4">Terms of Service</h1>

        <p className="mb-4">
          By accessing or using Itinex, you agree to comply with the following terms.
          Please read them carefully.
        </p>

        <h2 className="font-bold mt-6 mb-2">Platform Usage</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>You agree to use Itinex for lawful purposes only</li>
          <li>You will not attempt to disrupt platform services</li>
          <li>You are responsible for any content you submit</li>
        </ul>

        <h2 className="font-bold mt-6 mb-2">Accuracy Disclaimer</h2>
        <p>
          While we strive to provide accurate travel information, Itinex does not
          guarantee completeness or real-time accuracy of third-party data sources.
        </p>

        <h2 className="font-bold mt-6 mb-2">Limitation of Liability</h2>
        <p>
          Itinex is not responsible for travel disruptions, booking issues, or losses
          arising from itinerary use.
        </p>

        <p className="mt-6 text-sm text-slate-500">
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </section>

    )}
  </>
)}


        {location.pathname === "/saved" && step === "saved" && (
  <div id="saved" className="space-y-6">
    <div className="flex items-center justify-between flex-wrap gap-3">
      <div>
        <h2 className="text-2xl font-extrabold text-gray-900">Saved Trips</h2>
        <p className="text-gray-600 text-sm">Your trips saved in this browser</p>
      </div>

      <button
        type="button"
        onClick={() => setStep("select")}
        className="px-4 py-2 rounded-xl border bg-white text-gray-700 hover:bg-gray-50 text-sm font-semibold"
      >
        Plan a new trip
      </button>
    </div>

    {savedTrips.length === 0 ? (
      <div className="bg-white rounded-2xl border p-10 text-center text-gray-600">
        <div className="text-lg font-semibold text-gray-900">No saved trips yet</div>
        <p className="mt-2 text-sm text-gray-600">
          Generate an itinerary and it’ll be saved automatically.
        </p>
      </div>
    ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {savedTrips.map((t) => (
          <div key={t.id} className="bg-white rounded-2xl border shadow-sm overflow-hidden">
            <div className="h-40 bg-gray-100">
              <img
                src={t?.selectedDest?.image || svgPlaceholderDataUrl(t?.selectedDest?.name || "Trip")}
                alt={t?.selectedDest?.name || "Trip"}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = svgPlaceholderDataUrl(t?.selectedDest?.name || "Trip");
                }}
              />
            </div>

            <div className="p-5">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="text-lg font-extrabold text-gray-900">{t.title}</div>
                  <div className="text-xs text-gray-500 mt-1">
                    Saved {new Date(t.ts).toLocaleString()}
                  </div>
                  {t.startDate && t.endDate && (
                    <div className="text-xs text-gray-600 mt-1">
                      {t.startDate} → {t.endDate}
                    </div>
                  )}
                </div>
              </div>

              <div className="mt-4 flex items-center gap-5">
                <a
  href="#"
  onClick={(e) => {
    e.preventDefault();
    openSavedTrip(t);
  }}
  className="text-itinex-primary text-sm font-semibold hover:underline"
>
  Open
</a>

<a
  href="#"
  onClick={(e) => {
    e.preventDefault();
    saveCurrentTrip();
  }}
  className="text-gray-700 text-sm hover:text-itinex-primary hover:underline"
>
  Save trip
</a>



                {t.shareUrl ? (
                	<a
  href="#"
  onClick={(e) => {
    e.preventDefault();
    copyToClipboard(t.shareUrl)
  }}
  className="text-gray-700 text-sm hover:text-itinex-primary hover:underline"
>
  Copy link
</a>
                ) : null}

                <button
  type="button"
  onClick={() => {
  if (window.confirm("Delete this saved trip?")) {
    deleteSavedTrip(t.id);
  }
}}
  className="ml-auto p-2 rounded-full text-red-500 hover:bg-red-50 hover:text-red-600 transition"
  title="Delete trip"
  aria-label="Delete trip"
>
  <Trash2 className="w-4 h-4" />
</button>

              </div>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
)}

{location.pathname === "/" && (
  <HomePage
    onStartPlanning={() => {
      navigate("/destinations");
      setTimeout(() => scrollToSection("destinations"), 50);
    }}
    onExploreDestinations={() => {
      navigate("/destinations");
      setTimeout(() => scrollToSection("destinations"), 50);
    }}
    onScrollToHowItWorks={() => {
      document.getElementById("how-it-works")?.scrollIntoView({ behavior: "smooth" });
    }}
  />
)}



        {location.pathname === "/destinations" && step === "select" && (  
  <div id="destinations" className="space-y-6">
	        <div className="flex items-center justify-center gap-2 mb-6">
			  <button
			    type="button"
			    onClick={() => setSelectView('grid')}
			    className={`px-4 py-2 rounded-xl border text-sm font-semibold transition
			      ${selectView === 'grid' ? 'bg-gray-900 text-white border-gray-900' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
			  >
			    Grid view
			  </button>

			  <button
			    type="button"
			    onClick={() => setSelectView('map')}
			    className={`px-4 py-2 rounded-xl border text-sm font-semibold transition
			      ${selectView === 'map' ? 'bg-gray-900 text-white border-gray-900' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
			  >
			    Map view
			  </button>
			</div>


            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Choose Your Dream Destination</h2>
              <p className="text-gray-600">Select from popular tourist spots and read reviews</p>
            </div>

            {selectView === 'grid' ? (
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
  {destinations.map((dest) => {
    const key = destKey(dest); // ✅ stable destination_id key

    const reviewsForDest = destinationReviews[key] || [];
    const reviewCount = reviewsForDest.length;
    const avgRating = getAverageRating(key);

    return (
      <div
        key={key}
        className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
      >
        {/* Clickable image/header */}
        <div
          onClick={() => navigate(`/destinations/${slugify(`${dest.name}-${dest.country}`)}`)}
          className="cursor-pointer"
        >
          <div className="relative h-48 overflow-hidden bg-gray-200">
            <img
              src={dest.image}
              alt={dest.name}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = svgPlaceholderDataUrl(dest.name);
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-4 left-4 right-4">
              <h3 className="text-white font-bold text-lg">{dest.name}</h3>
              <p className="text-white text-sm">{dest.country}</p>
            </div>
          </div>
        </div>

        {/* Card body */}
        <div className="p-4">
          <div className="flex items-center justify-between mb-3">
            {/* Rating + count */}
            <div className="flex items-center gap-1">
              {Number(avgRating) > 0 ? (
                <>
                  <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                  <span className="text-sm font-semibold text-gray-900">
                    {avgRating}
                  </span>
                  <span className="text-xs text-gray-500">
                    ({reviewCount})
                  </span>
                </>
              ) : (
                <span className="text-xs text-gray-500">No reviews yet</span>
              )}
            </div>

            {/* Reviews button */}
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                openReviewModal(dest); // ✅ opens modal + fetches Supabase reviews
              }}
              className="text-xs text-itinex-secondary hover:text-itinex-primary font-semibold"
              title="View reviews"
            >
              Reviews
            </button>
          </div>

          {/* Explore CTA */}
          <div
            onClick={() => navigate(`/destinations/${slugify(`${dest.name}-${dest.country}`)}`)}
            className="flex items-center justify-between cursor-pointer"
          >
            <span className="text-sm text-gray-600">Explore destination</span>
            <ChevronRight className="w-5 h-5 text-itinex-secondary group-hover:translate-x-1 transition-transform" />
          </div>

          {/* Optional: small helpful line */}
          <div className="mt-3 text-xs text-gray-500">
            {reviewCount > 0
              ? `Top-rated by travelers • ${reviewCount} review${reviewCount === 1 ? "" : "s"}`
              : "Be the first to review this destination"}
          </div>
        </div>
      </div>
    );
  })}
</div>

		) : (
		  <DestinationLeafletPicker
		    destinations={destinations}
		    onPick={(dest) => handleSelectDestination(dest)} // ✅ click marker goes to Step 2
		  />
		)}

          </div>
        )}

        {step === 'days' && selectedDest && (
          <div className="max-w-2xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <div className="text-center mb-8">
                <div className="inline-block p-4 bg-gradient-to-br from-itinex-secondary to-itinex-primary rounded-2xl mb-4">
                  <Calendar className="w-12 h-12 text-white" />
                </div>
                <h2 className="text-3xl font-bold text-gray-900 mb-2">Plan Your Trip to {selectedDest.name}</h2>
                <p className="text-gray-600">How many days will you be staying?</p>
              </div>

              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-3">
                    Number of Days: <span className="text-2xl font-bold text-blue-600">{days}</span>
                  </label>
                  <div className="mb-6 p-4 rounded-xl border bg-gray-50">
				  <div className="flex items-center justify-between gap-3 flex-wrap">
				    <div className="text-sm font-semibold text-gray-900">Trip dates</div>
				    <label className="inline-flex items-center gap-2 text-sm text-gray-700">
				      <input
				        type="checkbox"
				        checked={useDateRange}
				        onChange={(e) => setUseDateRange(e.target.checked)}
				      />
				      Use date range
				    </label>
				  </div>

				  {useDateRange ? (
				    <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-3">
				      <div>
				        <label className="block text-xs font-medium text-gray-600 mb-1">Start</label>
				        <input
				          type="date"
				          value={startDate}
                    min={new Date().toISOString().slice(0, 10)}
				          onChange={(e) => {
				            const v = e.target.value;
				            setStartDate(v);
				            // keep end >= start
				            if (new Date(endDate) < new Date(v)) setEndDate(v);
				          }}
				          className="w-full px-3 py-2 rounded-lg border bg-white"
				        />
				      </div>

				      <div>
				        <label className="block text-xs font-medium text-gray-600 mb-1">End</label>
				        <input
				          type="date"
				          value={endDate}
				          min={startDate}
				          onChange={(e) => setEndDate(e.target.value)}
				          className="w-full px-3 py-2 rounded-lg border bg-white"
				        />
				      </div>

				      <div className="sm:col-span-2 text-xs text-gray-600">
				        Duration: <span className="font-semibold">{daysFromRange(startDate, endDate)}</span> day(s) (max 14)
				      </div>
				    </div>
				  ) : (
				    <div className="mt-3 text-xs text-gray-600">
				      Using slider below to choose number of days.
				    </div>
				  )}
				</div>

              {/* Hidden gems */}
        <div className="mt-4 p-4 rounded-xl border bg-gray-50">
          <div className="flex items-center justify-between gap-3 flex-wrap">
            <div>
              <div className="text-sm font-semibold text-gray-900">Hidden gems</div>
              <div className="text-xs text-gray-600">Prefer less touristy picks + more surprise</div>
            </div>

            <label className="inline-flex items-center gap-2 text-sm text-gray-700">
              <input
                type="checkbox"
                checked={hiddenGemsMode}
                onChange={(e) => setHiddenGemsMode(e.target.checked)}
              />
              Hidden gems mode
            </label>
          </div>

          {hiddenGemsMode && (
            <div className="mt-3">
              <label className="block text-xs font-medium text-gray-600 mb-1">
                Surprise level: <span className="font-semibold">{Math.round(surpriseLevel * 100)}%</span>
              </label>
              <input
                type="range"
                min="0"
                max="1"
                step="0.05"
                value={surpriseLevel}
                onChange={(e) => setSurpriseLevel(parseFloat(e.target.value))}
                className="w-full"
              />
              <button
                  type="button"
                  class="w-full bg-gradient-to-r from-itinex-secondary to-itinex-primary text-white py-4 rounded-xl font-semibold text-lg hover:from-itinex-secondary hover:to-itinex-primary transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  onClick={() => {
                    // keep user's chosen percent
                    setHiddenGemsMode(true);

                    // regenerate using current surpriseLevel
                    setTimeout(() => {
                      fetchWeather(selectedDest);
                    }, 0);
                  }}
                >
                  Surprise me ✨
                </button>
            </div>
          )}
        </div>
                  <input
                    type="range"
                    min="1"
                    max="14"
                    value={days}
                    onChange={(e) => {
                      const newDays = parseInt(e.target.value, 10);
                      setDays(newDays);

                      // ✅ if using date range, align end date with selected days
                      if (useDateRange && startDate) {
                        setEndDate(addDaysToISO(startDate, newDays - 1));
                      }
                    }}
                    className="w-full h-3 rounded-lg cursor-pointer"
                  />

                  <div className="flex justify-between text-xs text-gray-500 mt-2">
                    <span>1 day</span>
                    <span>14 days</span>
                  </div>
                </div>


                <button
                  onClick={handlePlanTrip}
                  disabled={loading}
                  className="w-full bg-gradient-to-r from-itinex-secondary to-itinex-primary text-white py-4 rounded-xl font-semibold text-lg hover:from-itinex-secondary hover:to-itinex-primary transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                

                  {loading ? (
                    <>
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                      Generating Your Perfect Itinerary...
                    </>
                  ) : (
                    <>
                      <Sparkles className="w-5 h-5" />
                      Generate Smart Itinerary
                    </>
                  )}
                </button>


              </div>
            </div>
          </div>
        )}
        {location.pathname === "/map" && step === "map" && (
		  <div id="map" className="space-y-6">
		    <div className="text-center mb-6">
		      <h2 className="text-2xl font-extrabold text-gray-900">
		        Choose a destination from the map
		      </h2>
		      <p className="text-gray-600">
		        Hover to explore • Click to plan your trip
		      </p>
		    </div>

		    {/* Map container */}
		    <div className="h-[70vh] rounded-2xl overflow-hidden border shadow">
		      {/* Leaflet map goes here */}
		      <DestinationMap
				  destinations={destinations}
				  loadingMapWeather={loadingMapWeather}
				  getDestCondition={(id) =>
				    mapWeatherById[id]?.condition || "cloudy"
				  }
				  onSelect={(dest) => {
				    setSelectedDest(dest);
				    setActiveNav("planner");
				    navigate("/planner/dates");
				  }}
				/>


		    </div>
		  </div>
		)}

        {step === 'itinerary' && itinerary.length > 0 && (
          <div id="itinerary" className="space-y-6">
            <div className="bg-white rounded-2xl shadow-xl p-6">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                <div>
                  <h2 className="text-3xl font-bold text-gray-900">
                    Your {days}-Day Adventure in {selectedDest.name}
                  </h2>
                  <div className="flex items-center gap-3 mt-2 text-sm text-gray-600 flex-wrap">
                    {weather && (
                      <span className="inline-flex items-center gap-2">
                        <Thermometer className="w-4 h-4" /> Live weather data
                      </span>
                    )}
                    {roomId && (
                      <span className="inline-flex items-center gap-2">
                        <Users className="w-4 h-4" /> {presenceCount} collaborating
                      </span>
                    )}
                    {attractionsSource && (
					  <span className="inline-flex items-center gap-2">
					    <Sparkles className="w-4 h-4" />
					    Attractions:{' '}
					    {attractionsSource === 'curated' && 'Curated for this destination'}
					    {attractionsSource === 'wikipedia' && 'Nearby real places'}
					    {attractionsSource === 'fallback' && 'General tourist highlights'}
					  </span>
					)}
					<span
					  title="How attraction suggestions were generated"
					  className="inline-flex items-center gap-2 cursor-help"
					/>

					                  </div>
					                </div>

					                <div className="flex flex-wrap gap-2">

					                  <button
                  					  onClick={exportToPdf}
                  					  disabled={exportingPdf}
                  					  className="inline-flex items-center gap-2 px-4 py-2 rounded-lg
                  					             bg-slate-800 text-white
                  					             hover:bg-slate-900
                  					             disabled:opacity-60"
                  					>
                  					  <FileText className="w-4 h-4" />
                  					  {exportingPdf ? "Exporting…" : "Export PDF"}
                  					</button>


					                  <button
                  					  onClick={downloadIcs}
                  					  className="inline-flex items-center gap-2 px-4 py-2 rounded-lg
                  					             bg-itinex-primary text-white
                  					             hover:bg-emerald-700"
                  					>
                  					  <Download className="w-4 h-4" />
                  					  Download .ics
                  					</button>


					                  <button
                  					  onClick={emailItinerary}
                  					  className="inline-flex items-center gap-2 px-4 py-2 rounded-lg
                  					             bg-itinex-secondary text-white
                  					             hover:bg-sky-700"
                  					>
                  					  <Mail className="w-4 h-4" />
                  					  Email
                  					</button>


					                 <button
                  					  onClick={handleWebShare}
                  					  className="inline-flex items-center gap-2 px-4 py-2 rounded-lg
                  					             bg-itinex-accent text-white
                  					             hover:bg-amber-600"
                  					>
                  					  <Share2 className="w-4 h-4" />
                  					  Share
                  					</button>

                        

                           <SkyscannerHeaderButton
                            href={skyscannerUrl}
                            label={selectedDest?.iata ? `Flights to ${selectedDest.iata}` : "Find flights"}
                            disabled={!selectedDest?.iata}
                          />


                          <select
                            value={toolsOpen}
                            onChange={(e) => {
                              const v = e.target.value;
                              setToolsOpen("");
                              if (v === "emergency") setEmergencyOpen(true);
                              if (v === "budget") setBudgetOpen(true);
                              if (v === "story") setStoryOpen(true);
                              if (v === "fix") setFixOpen(true);
                            }}
                            className="px-3 py-2 rounded-lg border bg-white text-sm font-semibold"
                          >
                            <option value="">More Features</option>
                            <option value="story">Travel Story</option>
                            <option value="budget">Budget Tracker</option>
                            <option value="fix">Fix My Day</option>
                          </select>

                          {viewMode === "story" && (
                            <button
                              onClick={() => setViewMode("itinerary")}
                              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border bg-white hover:bg-slate-50"
                            >
                              <ArrowLeft className="w-4 h-4" />
                              Back
                            </button>
          )}

          

                </div>
              </div>

              <div className="mt-5 grid grid-cols-1 lg:grid-cols-3 gap-4">
                <div className="lg:col-span-2">
                  <div className="text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                    <LinkIcon className="w-4 h-4" />
                    Share link (collaborative)
                  </div>
                  <div className="flex gap-2">
                    <input
                      value={shareUrl}
                      readOnly
                      className="w-full px-3 py-2 border rounded-lg bg-gray-50 text-gray-700 text-sm"
                    />
                    <button
                      onClick={() => copyToClipboard(shareUrl)}
                      className="px-3 py-2 rounded-lg border bg-white hover:bg-gray-50"
                      title="Copy link"
                    >
                      <Copy className="w-4 h-4" />
                    </button>
                  </div>
                </div>

                <div>
                  <div className="text-sm font-medium text-gray-700 mb-2">Share on</div>
                  <div className="flex flex-wrap gap-2">
                    <a className="px-3 py-2 rounded-lg border bg-white hover:bg-gray-50 text-sm" href={socialShareLinks.whatsapp} target="_blank" rel="noreferrer">
                      WhatsApp
                    </a>
                    <a className="px-3 py-2 rounded-lg border bg-white hover:bg-gray-50 text-sm" href={socialShareLinks.x} target="_blank" rel="noreferrer">
                      X
                    </a>
                    <a className="px-3 py-2 rounded-lg border bg-white hover:bg-gray-50 text-sm" href={socialShareLinks.facebook} target="_blank" rel="noreferrer">
                      Facebook
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-6">
            <UtilityFinderModal
              open={utilityModalOpen}
              onClose={() => setUtilityModalOpen(false)}
              data={utilityModalData}
              loading={utilityModalLoading}
            />

            <MicroExperiencesModal
              open={microOpen}
              onClose={() => setMicroOpen(false)}
              selectedDest={selectedDest}
              itinerary={itinerary}
            />


            {budgetOpen && (
              <div className="mt-6" id="budget-section">
              <BudgetTrackerModal
                open={budgetOpen}
                onClose={() => setBudgetOpen(false)}
                itinerary={itinerary}
                currency={currency}
                setCurrency={setCurrency}
                budgetData={budgetData}
                setBudgetData={setBudgetData}
              />
              </div>
            )}
            <TravelStoryModal
              open={storyOpen}
              onClose={() => setStoryOpen(false)}
              step={step}
              selectedDest={selectedDest}
              useDateRange={useDateRange}
              startDate={startDate}
              endDate={endDate}
              days={days}
              itinerary={itinerary}
              attractionImages={attractionImages}
              storySummaries={storySummaries}
              loadingStory={loadingStory}
              svgPlaceholderDataUrl={svgPlaceholderDataUrl}
              buildSixLineStory={buildSixLineStory}
              slugify={slugify}
              waitForImages={waitForImages}
              shareUrl={shareUrl}
              copyToClipboard={copyToClipboard}
              setError={setError}
              exportingPdf={exportingPdf}
              setExportingPdf={setExportingPdf}
              storyRef={storyRef}
              html2canvas={html2canvas}
              jsPDF={jsPDF}
            />
            <EmergencyHubModal
  open={emergencyOpen}
  onClose={() => setEmergencyOpen(false)}
  selectedDest={selectedDest}
  emergencyNumbers={emergencyNumbers}
  emergencyPhrases={emergencyPhrases}
/>



          <FixMyDay
            open={fixOpen}
            onClose={() => setFixOpen(false)}
            itinerary={itinerary}
            setItinerary={setItinerary}
            attractionsForTrip={attractionsForTrip}
            destinationName={selectedDest?.name || "your trip"}

            // optional image hydration (recommended)
            attractionImages={attractionImages}
            setAttractionImages={setAttractionImages}
            getAttractionImage={getAttractionImage}
          />

        <div className="flex items-center justify-between mb-4">
  <h2 className="text-2xl font-extrabold text-slate-900">
    Complete Itinerary
  </h2>

  <button
    type="button"
    onClick={() => setEmergencyOpen(true)}
    aria-label="Open emergency information"
    className="
      inline-flex items-center gap-2
      px-4 py-2.5
      rounded-full
      font-extrabold text-sm
      bg-white
      border-2 border-red-600
      text-red-600
      hover:bg-red-50
      shadow-md shadow-red-500/20
      transition-all duration-150
      active:scale-[0.97]
      focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2

    hover:[animation:emergency-shake_0.4s_ease-in-out]
    "
  >
    🚨 Emergency
  </button>
</div>

            
              <div className="space-y-4">
                {itinerary.map((day, idx) => (
		  <div
		    key={idx}
		    className="group rounded-2xl border border-gray-200 bg-white/80 backdrop-blur shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden"
		  >
		    {/* Header */}
		    <div className="p-6 pb-4 bg-gradient-to-br from-white to-gray-50">
		      <div className="flex items-start justify-between gap-4">
		        <div className="flex items-start gap-4">
		          <div className="shrink-0 w-14 h-14 rounded-2xl bg-gradient-to-br from-itinex-secondary to-itinex-primary text-white flex items-center justify-center font-extrabold text-lg shadow-md">
		            {day.day}
		          </div>

          <div>
            <div className="flex items-center gap-2 flex-wrap">
              <h3 className="text-xl font-extrabold text-gray-900 tracking-tight">
                Day {day.day}
              </h3>
              <span className="text-sm text-gray-500">• {day.date}</span>
            </div>

            <div className="mt-2 flex items-center gap-2 flex-wrap">
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full border bg-white text-sm text-gray-700">
                {getWeatherIcon(day.weatherCode)}
                <span className="capitalize">{day.condition}</span>
              </span>

              <span className="inline-flex items-center px-3 py-1 rounded-full border bg-white text-sm text-gray-700">
                {day.tempMax}°C / {day.tempMin}°C
              </span>

              <span className="inline-flex items-center px-3 py-1 rounded-full border bg-white text-sm text-gray-700">
                Rain {day.precipMm}mm{day.precipProb !== null ? ` • ${day.precipProb}%` : ''}
              </span>

              {day.windMax !== null && (
                <span className="inline-flex items-center px-3 py-1 rounded-full border bg-white text-sm text-gray-700">
                  Wind {day.windMax} km/h
                </span>
              )}
            </div>

            {day.sunrise && day.sunset && (
              <div className="mt-2 text-xs text-gray-500">
                Sunrise{' '}
                {new Date(day.sunrise).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}{' '}
                • Sunset{' '}
                {new Date(day.sunset).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </div>
            )}
          </div>
        </div>

        {/* Optional: little “vibe” badge */}
        <div className="hidden md:flex items-center gap-2 text-xs text-white">
          <span className="px-3 py-1 rounded-full bg-gradient-to-r from-itinex-secondary to-itinex-primary border">
            Photo picks + weather-aware
          </span>
        </div>
      </div>
    </div>
    {/* Square tiles */}
    <div className="p-6 pt-0">
      <div className="relative grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
        {/* Morning tile */}
        <div className="rounded-2xl border border-gray-200 overflow-hidden bg-white shadow-sm hover:shadow-lg transition-shadow">
		  <div className="relative aspect-square bg-gray-100">

		    <img
		      src={attractionImages[day.morning] || svgPlaceholderDataUrl(day.morning)}
		      alt={day.morning}
		      className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-300"
		      loading="lazy"
		      onError={(e) => {
		        e.currentTarget.onerror = null;
		        e.currentTarget.src = svgPlaceholderDataUrl(day.morning);
		      }}
		    />
<button
              className="text-white text-left font-semibold text-itinex-primary hover:underline"
              onClick={() => {
                setActivePlace(day.morning);
                setPlaceModalOpen(true);
                fetchPlaceDetails(day.morning);
              }}
            >
		    <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent" />

      </button>
		    <div className="absolute top-3 left-3 inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/90 backdrop-blur text-sm font-semibold text-gray-900">
		      ☀️ Morning
		    </div>

        
		    <div className="absolute top-3 right-3 flex items-center gap-2">
		  <button
		    type="button"
		    onClick={() => swapActivitiesForDay(day.day)}
		    className="inline-flex items-center px-3 py-1 rounded-full bg-black/50 hover:bg-black/65 text-white text-xs font-semibold backdrop-blur border border-white/15"
		    title="Swap morning and evening for this day"
		  >
		    Swap
		  </button>

		  <button
		    type="button"
		    onClick={() => replaceActivityForDay(day.day, 'morning')}
		    className="inline-flex items-center px-3 py-1 rounded-full bg-black/50 hover:bg-black/65 text-white text-xs font-semibold backdrop-blur border border-white/15"
		    title="Replace the morning activity with another suggestion"
		  >
		    Replace
		  </button>
		</div>


		    <div className="absolute bottom-0 left-0 right-0 p-3">
        <div className="flex items-center justify-between gap-3">
		      <div className="text-white font-bold text-lg leading-snug drop-shadow">
		        <button
              className="text-white text-left font-semibold text-itinex-primary hover:underline"
              onClick={() => {
                setActivePlace(day.morning);
                setPlaceModalOpen(true);
                fetchPlaceDetails(day.morning);
              }}
            >
              {day.morning}
            </button>

		      </div>
         <div className="absolute bottom-3 right-3 z-20 pointer-events-auto">
          <VoteBar
            k={activityId(selectedDest?.name, day.morning)}
            totals={voteTotals}
            onVote={(key, delta) => applyVote(key, delta)}
          />
        </div>

      </div>
		      <div className="text-white/85 text-xs mt-1 flex items-center gap-1">
              Best for {day.condition === 'rainy' ? 'indoors nearby' : 'exploring'}
          </div>
          <div className="space-y-2">
            <div className="rounded-2xl border border-gray-200 overflow-hidden bg-white shadow-sm hover:shadow-lg transition-shadow">
    </div>
          <div className="flex items-center gap-3 justify-start">
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); openNearestUtility(day.morning, "hospital"); }}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-white text-xs font-extrabold hover:text-white text-xs font-semibold border border-white"
    >
      🏥
    </button>

    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); openNearestUtility(day.morning, "pharmacy"); }}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-white text-xs font-extrabold hover:text-white text-xs font-semibold border border-white"
    >
      💊
    </button>
  </div>
		    </div>
        </div>
		  </div>
		</div>

            

            {/* Desktop timeline connector */}
			<div className="hidden md:block pointer-events-none absolute inset-0">
			  <div className="absolute left-1/2 top-[6.5rem] bottom-[6.5rem] -translate-x-1/2 w-px bg-gradient-to-b from-orange-400 via-gray-300 to-indigo-400" />

			  {/* Morning dot */}
			  <div className="absolute left-1/2 top-[6rem] -translate-x-1/2 w-3 h-3 rounded-full bg-orange-500 shadow" />

			  {/* Evening dot */}
			  <div className="absolute left-1/2 bottom-[6rem] -translate-x-1/2 w-3 h-3 rounded-full bg-indigo-500 shadow" />
			</div>


			{/* Mobile timeline connector */}
			<div className="md:hidden flex items-center justify-center">
			  <div className="relative w-full h-8 flex items-center">
			    <div className="absolute left-0 right-0 h-px bg-gradient-to-r from-orange-400 via-gray-300 to-indigo-400" />
			    <div className="mx-auto w-3 h-3 rounded-full bg-indigo-500 shadow" />
			  </div>
			</div>

        {/* Evening tile */}
        {/* Evening tile */}
<div className="rounded-2xl border border-gray-200 overflow-hidden bg-white shadow-sm hover:shadow-lg transition-shadow">
  <div className="relative aspect-square bg-gray-100">

    <img
      src={attractionImages[day.evening] || svgPlaceholderDataUrl(day.evening)}
      alt={day.evening}
      className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-300"
      loading="lazy"
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = svgPlaceholderDataUrl(day.evening);
      }}
    />

    {/* overlay gradient (do NOT capture clicks) */}
    <div className="absolute inset-0 z-10 bg-gradient-to-t from-black/65 via-black/10 to-transparent pointer-events-none" />

    {/* Optional: click-anywhere to open details (doesn't block VoteBar) */}
    <button
      type="button"
      className="absolute inset-0 z-10"
      onClick={() => {
        setActivePlace(day.evening);
        setPlaceModalOpen(true);
        fetchPlaceDetails(day.evening);
      }}
      aria-label={`Open details for ${day.evening}`}
      style={{ background: "transparent" }}
    />

    <div className="absolute top-3 left-3 z-20 inline-flex items-center gap-2 px-3 py-1 rounded-full bg-black/90 backdrop-blur text-sm font-semibold text-white">
      🌙 Evening
    </div>
    <div className="absolute top-3 right-3 z-20 flex items-center gap-2">
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); swapActivitiesForDay(day.day); }}
        className="inline-flex items-center px-3 py-1 rounded-full bg-black/50 hover:bg-black/65 text-white text-xs font-semibold backdrop-blur border border-white/15"
        title="Swap morning and evening for this day"
      >
        Swap
      </button>

      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); replaceActivityForDay(day.day, "evening"); }}
        className="inline-flex items-center px-3 py-1 rounded-full bg-black/50 hover:bg-black/65 text-white text-xs font-semibold backdrop-blur border border-white/15"
        title="Replace the evening activity with another suggestion"
      >
        Replace
      </button>
    </div>

    {/* VoteBar - ABOVE overlays */}
    <div className="absolute bottom-3 right-3 z-30 pointer-events-auto">
      <VoteBar
        k={activityId(selectedDest?.name, day.evening)}
        totals={voteTotals}
        onVote={applyVote}
      />
    </div>

    <div className="absolute bottom-0 left-0 right-0 z-20 p-3">
      <div className="text-white font-bold text-lg leading-snug drop-shadow">
        <button
          type="button"
          className="text-white text-left font-semibold hover:underline"
          onClick={(e) => {
            e.stopPropagation();
            setActivePlace(day.evening);
            setPlaceModalOpen(true);
            fetchPlaceDetails(day.evening);
          }}
        >
          {day.evening}
        </button>
      </div>

      <div className="text-white/85 text-xs mt-1 flex items-center gap-1">
        Great for {day.tempMax >= 24 ? "late strolls" : "cozy spots"}
      </div>
      <div className="space-y-2">
  <div className="rounded-2xl border border-gray-200 overflow-hidden bg-white shadow-sm hover:shadow-lg transition-shadow">
    </div>

  {/* Buttons BELOW tile (LEFT aligned) */}
  <div className="flex items-center gap-3 justify-start">
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); openNearestUtility(day.evening, "hospital"); }}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-white text-xs font-extrabold hover:text-white hover:text-white text-xs font-semibold border border-white"
    >
      🏥
    </button>

    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); openNearestUtility(day.evening, "pharmacy"); }}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-white text-xs font-extrabold hover:text-white hover:text-white text-xs font-semibold border border-white"
    >
      💊
    </button>
  </div>
</div>

    </div>

  </div>
</div>

			      </div>
			    </div>
			  </div>
			))}


              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-6">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                  <MessageCircle className="w-5 h-5 text-gray-700" />
                  <h3 className="text-lg font-bold text-gray-900">Collaborative Notes</h3>
                </div>
                <div className="text-sm text-gray-600 inline-flex items-center gap-2">
                  <Users className="w-4 h-4" /> {presenceCount} online
                </div>
                {/* ✅ New Micro Experiences button */}
                  <button
                    type="button"
                    className="
    inline
    px-2 py-1 border-itinex-primary
    text-itinex-primary font-semibold
    bg-white
    transition-all duration-150"
                    onClick={() => setMicroOpen(true)} 
                    title="Open Micro Experiences"
                  >Discover Experiences in {selectedDest.name}
                  </button>   
              </div>

              <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-4">
                <input
                  className="px-3 py-2 border rounded-lg bg-gray-50"
                  value={commentName}
                  onChange={(e) => setCommentName(e.target.value)}
                  placeholder="Your name"
                />
                <input
                  className="md:col-span-2 px-3 py-2 border rounded-lg bg-white"
                  value={commentText}
                  onChange={(e) => setCommentText(e.target.value)}
                  placeholder="Add a note..."
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') addCommentLocalAndCollaborative();
                  }}
                />
                <button
                  onClick={addCommentLocalAndCollaborative}
                  className="px-4 py-2 rounded-lg bg-gray-900 text-white hover:bg-gray-800"
                >
                  Add
                </button>
              </div>

              <div className="space-y-3">
                {comments.slice().sort((a, b) => (a.ts || 0) - (b.ts || 0)).map((c) => (
                  <div key={c.id} className="border rounded-lg p-3 bg-gray-50">
                    <div className="text-sm font-semibold text-gray-900">{c.author}</div>
                    <div className="text-sm text-gray-700">{c.text}</div>
                    <div className="text-xs text-gray-500 mt-1">{new Date(c.ts).toLocaleString()}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="sr-only">
              <div ref={pdfRef} className="bg-white p-8" style={{ width: 794 }}>
                <div style={{ fontSize: 24, fontWeight: 800, marginBottom: 16 }}>Holiday Itinerary</div>
                <div style={{ fontSize: 14, color: '#444', marginBottom: 24 }}>
                  {selectedDest?.name} — {days} days
                </div>

                <img
				  src={selectedDest.image}
				  crossOrigin="anonymous"
				  alt="Destination"
				  style={{ width: '100%', height: 260, objectFit: 'cover', borderRadius: 12, marginBottom: 16 }}
				  onError={(e) => {
				    e.currentTarget.onerror = null;
				    e.currentTarget.src = svgPlaceholderDataUrl(selectedDest.name);
				  }}
				/>


         {itinerary.map((d) => {
  const dayKey = d.isoDate || d.date || `day-${d.day}`;
const extras = microExtrasByDay?.[dayKey] || [];

  return (
    <React.Fragment key={d.day}>
      <div style={{ marginBottom: 22, borderTop: "1px solid #eee", paddingTop: 16 }}>
        <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 8 }}>
          Day {d.day}: {d.date} — {d.condition}, {d.temp}°C
        </div>

        <div style={{ marginBottom: 6 }}>
          <strong>Morning:</strong> {d.morning}
        </div>

        <div>
          <strong>Evening:</strong> {d.evening}
        </div>

        {extras.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-2">
            {extras.slice(0, 4).map((x) => (
              <a
                key={x.id || x.title}
                href={x.url || "#"}
                target={x.url ? "_blank" : undefined}
                rel={x.url ? "noreferrer" : undefined}
                onClick={(e) => {
                  if (!x.url) e.preventDefault();
                }}
                className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border bg-white text-xs font-semibold text-slate-700 hover:bg-slate-50"
                title={x.short || x.title}
              >
                {x.kind === "guide" ? "🧑‍🏫" : "🎟️"} {x.title}
              </a>
            ))}

            {extras.length > 4 && (
              <button
                type="button"
                onClick={() => setMicroOpen(true)}
                className="px-3 py-1.5 rounded-full border bg-white text-xs font-semibold hover:bg-slate-50"
              >
                +{extras.length - 4} more
              </button>
            )}
          </div>
        )}
      </div>
    </React.Fragment>
  );
})}

              </div>
            </div>
          </div>
        )} </div>
    </main>
    <aside className="hidden xl:block" style={{padding:'10px'}}>
      <div className="sticky top-24 space-y-6">
        <AdSlot id="ad-right-1" label="Right rail (300×600)" className="h-[600px]" />
        <AdSlot id="ad-right-2" label="Right rail (300×250)" className="h-[250px]" />
      </div>
    </aside>

  </div>
</div>
      </div>

  

      {showReviews && selectedReviewDest && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col">
            <div className="p-6 border-b flex items-center justify-between">
              <div>
                <h3 className="text-2xl font-bold text-gray-900">{selectedReviewDest.name}</h3>
                <div className="flex items-center gap-2 mt-1">
                  <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  <span className="font-semibold">{getAverageRating(selectedReviewDest.id) || 'No ratings'}</span>
                  <span className="text-sm text-gray-500">
                    ({(destinationReviews[selectedReviewDest.id] || []).length} reviews)
                  </span>
                </div>
              </div>
              <button
                onClick={() => setShowReviews(false)}
                className="p-2 hover:bg-gray-100 rounded-lg"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6">
              <div className="bg-gradient-to-br from-itinex-secondary to-itinex-primary rounded-xl p-6 mb-6">
                <h4 className="text-lg font-bold mb-4">Write a Review</h4>
                
                <div className="space-y-4">
                  <input
                    type="text"
                    value={reviewName}
                    onChange={(e) => setReviewName(e.target.value)}
                    placeholder="Your name"
                    className="w-full px-4 py-2 border rounded-lg"
                  />

                  <div>
                    <div className="flex gap-2 mb-2">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <button
                          key={star}
                          onClick={() => setReviewRating(star)}
                          className="transition-transform hover:scale-110"
                        >
                          <Star
                            className={`w-8 h-8 ${
                              star <= reviewRating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'
                            }`}
                          />
                        </button>
                      ))}
                    </div>
                  </div>

                  <textarea
                    value={reviewText}
                    onChange={(e) => setReviewText(e.target.value)}
                    placeholder="Share your experience..."
                    rows={4}
                    className="w-full px-4 py-2 border rounded-lg resize-none"
                  />

                  <button
                    onClick={addDestinationReview}
                    disabled={!reviewText.trim()}
                    className="w-full bg-gradient-to-r from-itinex-secondary to-itinex-primary text-white py-3 rounded-lg font-semibold hover:from-itinex-secondary hover:to-itinex-primary disabled:opacity-50"
                  >
                    Submit Review
                  </button>
                </div>
              </div>

              <div>
                <h4 className="text-lg font-bold mb-4">
                  All Reviews ({(destinationReviews[selectedReviewDest.id] || []).length})
                </h4>
                
                {(destinationReviews[selectedReviewDest.id] || []).length === 0 ? (
                  <div className="text-center py-12 text-gray-500">
                    <Star className="w-12 h-12 text-gray-300 mx-auto mb-3" />
                    <p>No reviews yet. Be the first!</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {(destinationReviews[selectedReviewDest.id] || [])
                      .slice()
                      .sort((a, b) => b.ts - a.ts)
                      .map((review) => (
                        <div key={review.id} className="bg-white border rounded-xl p-4">
                          <div className="flex justify-between mb-2">
                            <div>
                              <div className="font-semibold">{review.author}</div>
                              <div className="flex gap-1 mt-1">
                                {[1, 2, 3, 4, 5].map((star) => (
                                  <Star
                                    key={star}
                                    className={`w-4 h-4 ${
                                      star <= review.rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'
                                    }`}
                                  />
                                ))}
                              </div>
                            </div>
                            <span className="text-xs text-gray-500">
                              {new Date(review.ts).toLocaleDateString()}
                            </span>
                          </div>
                          <p className="text-sm text-gray-700">{review.text}</p>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {placeModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-xl max-w-lg w-full p-6 relative">
            
            <button
              className="absolute top-3 right-3 text-slate-500 hover:text-slate-700"
              onClick={() => setPlaceModalOpen(false)}
            >
              ✕
            </button>

            {placeLoading ? (
              <p className="text-sm text-slate-500">Loading details…</p>
            ) : placeDetails ? (
              <>
                <h3 className="text-xl font-bold mb-2">
                  {placeDetails.title}
                </h3>

                {placeDetails.image && (
                  <img
                    src={placeDetails.image}
                    alt={placeDetails.title}
                    className="w-full h-48 object-cover rounded-lg mb-3"
                  />
                )}
                <p className="text-sm text-slate-700 mb-1">
                  Cost: {Array(getCostLevel(placeDetails.title, placeDetails.description)).fill('💎').join('')}
                </p>

                <p className="text-sm text-slate-700 mb-3">
                  {placeDetails.description}
                </p>
                {nearbyPlaces.length > 0 && (
                  <div className="mt-4">
                    <h4 className="text-sm font-bold text-slate-900 mb-2">
                      Nearby attractions
                    </h4>

                    <ul className="space-y-1">
                      {nearbyPlaces.map((place) => (
                        <li key={place} className="flex items-center justify-between gap-2">
                        <button
                          className="text-sm text-itinex-primary hover:underline"
                          onClick={() => {
                            setActivePlace(place);
                            fetchPlaceDetails(place);
                          }}
                        >
                          {place}
                        </button>

                        <button
                          className="text-xs text-slate-500 hover:text-itinex-primary"
                          onClick={() => swapWithNearbyPlace(place)}
                          title="Swap with this activity"
                        >
                          Swap
                        </button>
                      </li>
                      ))}
                    </ul>
                  </div>
                )}


                {placeDetails.url && (
                  <a
                    href={placeDetails.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-semibold text-itinex-primary hover:underline"
                  >
                    Read more on Wikipedia →
                  </a>
                )}
                <div>
                {/*<button
                    onClick={() => openGoogleMapsDirections(placeDetails.title)}
                    className="mt-3 inline-flex items-center gap-2 rounded-lg bg-itinex-primary px-4 py-2 text-sm font-semibold text-white hover:opacity-90"
                  >
                    📍 Get directions
                  </button>*/}
                </div>
              </>
            ) : null}
          </div>
        </div>
      )}




                      <footer className="border-t bg-slate-50 mt-20">
  <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">

    {/* Brand */}
    <div>
      <div className="font-extrabold text-lg text-slate-900">Itinex</div>
      <p className="mt-2 text-slate-600 text-xs">
        Plan less. Explore more.<br />
        Smart, weather-aware travel planning.
      </p>
    </div>

    {/* Product */}
    <div>
      <h4 className="font-semibold text-slate-900 mb-3">Product</h4>
      <ul className="space-y-2">
        <li><FooterLink label="Destinations" nav="destinations" /></li>
        <li><FooterLink label="Map View" nav="map" /></li>
        <li><FooterLink label="Saved Trips" nav="saved" /></li>
      </ul>
    </div>

    {/* Company */}
    <div>
      <h4 className="font-semibold text-slate-900 mb-3">Company</h4>
      <ul className="space-y-2">
        <li><FooterLink label="About Itinex" nav="about" /></li>
         <li><FooterLink label="Contact" nav="contact" /></li>
         <li><FooterLink label="Advertise with Us" nav="advertise" /></li>
      </ul>
    </div>

    {/* Legal */}
    <div>
      <h4 className="font-semibold text-slate-900 mb-3">Legal</h4>
      <ul className="space-y-2">
         <li><FooterLink label="Privacy Policy" nav="privacy" /></li>
         <li><FooterLink label="Terms of Service" nav="terms" /></li>
      </ul>
    </div>
  </div>

  <div className="text-center text-xs text-slate-500 pb-6">
    © {new Date().getFullYear()} Itinex · itinex.net
  </div>
</footer>



    </div>
  );
}

function slugify(s) {
  return String(s ?? "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");
}


function hashString(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24);
  }
  return (h >>> 0).toString(36);
}

function cryptoRandomId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function icsEscape(s) {
  return String(s || '').replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
}

async function waitForImages(el) {
  const imgs = Array.from(el.querySelectorAll('img'));
  await Promise.all(imgs.map(img => new Promise(resolve => {
    if (img.complete) return resolve(true);
    img.onload = () => resolve(true);
    img.onerror = () => resolve(true);
  })));
}

let _collab = null;

function safeDestroyCollab() {
  if (!_collab) return;
  try { if (_collab.yComments && _collab._onComments) _collab.yComments.unobserve(_collab._onComments); } catch {}
  try { if (_collab.provider && _collab._onAwareness) _collab.provider.awareness.off('change', _collab._onAwareness); } catch {}
  try { _collab.provider?.destroy?.(); } catch {}
  try { _collab.ydoc?.destroy?.(); } catch {}
  try { if (_collab.yVotes && _collab._onVotes) _collab.yVotes.unobserve(_collab._onVotes); } catch {}

  _collab = null;
}

function ensureCollabSingleton(roomId, userName, setComments, setPresenceCount, setVotes) {
  if (!roomId) return;

  if (_collab?.roomId === roomId && _collab.provider && _collab.ydoc) {
    try { _collab.provider.awareness.setLocalStateField('user', { name: userName || 'Anonymous' }); } catch {}
    _collab.setComments = setComments;
    _collab.setPresenceCount = setPresenceCount;
    _collab.setVotes = setVotes;
    try {
      setComments(_collab.yComments?.toArray?.() ?? []);
      const states = Array.from(_collab.provider.awareness.getStates().values());
      setPresenceCount(Math.max(1, states.length));
    } catch {}
    return;
  }

  safeDestroyCollab();

  const ydoc = new Y.Doc();
  const provider = new WebrtcProvider(roomId, ydoc);
  const yComments = ydoc.getArray('comments');
  const yVotes = ydoc.getMap('votes'); 

const onVotes = () => {
  try {
    const obj = {};
    _collab.yVotes.forEach((val, key) => { obj[key] = val; });
    setVotes(obj); 
  } catch {}
};


_collab = {
  roomId, ydoc, provider,
  yComments,
  yVotes,                 // ✅ add
  setComments, setPresenceCount,
  setVotes,
  _onComments: null, _onAwareness: null,
  _onVotes: null          // ✅ add
};

  try { provider.awareness.setLocalStateField('user', { name: userName || 'Anonymous' }); } catch {}

  const onComments = () => { try { _collab?.setComments?.(yComments.toArray()); } catch {} };
  const onAwareness = () => { 
    try {
      const states = Array.from(provider.awareness.getStates().values());
      _collab?.setPresenceCount?.(Math.max(1, states.length));
    } catch {}
  };

  _collab._onComments = onComments;
  _collab._onAwareness = onAwareness;

  yComments.observe(onComments);
  const onVotesObs = () => onVotes();
  _collab._onVotes = onVotesObs;
  yVotes.observe(onVotesObs);
  onVotesObs();

  provider.awareness.on('change', onAwareness);

  if (yComments.length === 0) {
    yComments.push([{
      id: cryptoRandomId(),
      author: 'Planner',
      text: 'Add notes here — everyone can collaborate in real-time.',
      ts: Date.now()
    }]);
  }

  onComments();
  onAwareness();
}


function addCommentViaSingleton(author, text, setComments) {
  if (!_collab?.yComments) {
    setComments(prev => [...prev, { id: cryptoRandomId(), author, text, ts: Date.now() }]);
    return;
  }
  _collab.yComments.push([{ id: cryptoRandomId(), author, text, ts: Date.now() }]);
}